import { cardRefundsEn, cardRefundsPtBr } from '@/lib/i18n/card-refunds';
import { revenueTaxEn, revenueTaxPtBr } from '@/lib/i18n/revenue-tax';

export const tenantSettingsPtBr = {
  ...revenueTaxPtBr,
  businessContext: {
    title: 'Configurações globais',
    subtitle: 'Defina o contexto do negócio para orientar classificações de contas a pagar',
    card: {
      title: 'Contexto do negócio',
      description:
        'Explique brevemente o que a empresa faz, seus produtos/serviços e padrões de despesa.',
    },
    field: {
      label: 'Descrição do contexto',
      placeholder: 'Ex.: SaaS B2B com foco em assinaturas e infraestrutura cloud.',
      helper: 'Mantenha o texto curto. Ele será usado para orientar o assistente de IA.',
    },
    footer: {
      noChanges: 'Nenhuma alteração registrada',
      lastUpdated: 'Atualizado em {{date}}',
    },
    buttons: {
      discard: 'Descartar Alterações',
      save: 'Salvar Configurações',
      saving: 'Salvando...',
    },
    loading: 'Carregando configurações...',
    error: 'Não foi possível carregar as configurações.',
    toasts: {
      saved: 'Configurações salvas.',
      saveError: 'Não foi possível salvar as configurações.',
    },
    charCount: '{{count}} / {{max}} caracteres',
  },
  approvalGlobal: {
    title: 'Configurações de Aprovação',
    subtitle: 'Defina regras globais para o fluxo de aprovação de contas',
    loading: 'Carregando configurações...',
    footer: {
      noChanges: 'Nenhuma alteração registrada',
      readOnly: 'Somente leitura. Editar exige permissão de gerenciar configurações.',
    },
    buttons: {
      history: 'Histórico',
      discard: 'Descartar Alterações',
      save: 'Salvar Configurações',
      saving: 'Salvando...',
    },
    tabs: {
      approvals: 'Aprovações',
      requiredFields: 'Campos obrigatórios',
    },
  },
  emailInboxes: {
    card: {
      title: 'Caixas de entrada por e-mail',
      description:
        'Gerencie os endereços de e-mail que podem receber documentos e mensagens para triagem.',
    },
    list: {
      loading: 'Carregando caixas de entrada...',
      error: 'Não foi possível carregar as caixas de entrada.',
      empty: 'Nenhuma caixa de entrada configurada.',
      emptyForEntity: 'Nenhuma caixa de entrada configurada para {{entity}}.',
      alsoServes: 'Também atende: {{entities}}',
    },
    dialog: {
      createTitle: 'Criar caixa de entrada',
      editTitle: 'Editar caixa de entrada',
      createDescription: 'Configure o endereço que recebe documentos e as empresas que ele atende.',
      editDescription: 'Atualize o nome do e-mail e as empresas atendidas desta caixa de entrada.',
    },
    fields: {
      entity: 'Empresa padrão',
      defaultEntity: 'Empresa padrão',
      entityPlaceholder: 'Selecione a empresa padrão',
      defaultEntityPlaceholder: 'Selecione a empresa padrão',
      defaultEntityHelper:
        'Usada quando não identificamos a empresa pelo documento ou pelo e-mail.',
      email: 'Endereço de e-mail',
      localPart: 'Nome do e-mail',
      localPartPlaceholder: 'Ex.: ap+acme',
      localPartHelper:
        'Use um termo da empresa padrão, do grupo ou do tenant. A empresa identificada no documento ou no e-mail vence; caso contrário, usamos a empresa padrão.',
      allowedSenders: 'Remetentes permitidos',
      allowedSendersHelper:
        'Deixe vazio para aceitar qualquer remetente. Adicione e-mails completos (ex.: fornecedor@empresa.com) ou domínios (ex.: @empresa.com ou empresa.com). Subdomínios exigem entrada explícita.',
      allowedSendersPlaceholder: 'Digite e pressione Enter',
      allowedSendersCount: '{{count}} / {{max}} entradas',
      removeAllowedSender: 'Remover entrada da lista',
      allowedUrlDomains: 'Domínios de links permitidos',
      allowedUrlDomainsHelper:
        'Domínios cujos links no corpo do e-mail podem ser baixados como anexos. Para Pipefy, use app.pipefy.com. Deixe vazio para não baixar links do corpo.',
      allowedUrlDomainsPlaceholder: 'Ex.: app.pipefy.com',
      allowedUrlDomainsCount: '{{count}} / {{max}} domínios',
      removeAllowedUrlDomain: 'Remover domínio da lista',
      autoReplyEnabled: 'Responder remetentes automaticamente',
      autoReplyEnabledHelper:
        'Desligado, o agente não envia e-mails a quem mandou a mensagem. Quando faltar algo que só o remetente pode informar, o e-mail vai para "E-mails que não viraram conta".',
      badgeOpen: 'Aceita todos',
      badgeRestricted: 'Restrito',
      sharedEntities: 'Empresas atendidas',
      sharedEntitiesHelper:
        'A empresa padrão está sempre incluída. Só com a padrão, cada documento vai para a empresa do CNPJ dele, ou para a padrão quando não há CNPJ. Com mais de uma empresa, um e-mail que não indica a empresa fica aguardando alguém escolher.',
      sharedEntitiesDefaultTag: 'Padrão',
      sharedEntitiesAll: 'Todas as empresas',
      sharedEntitiesPlaceholder: 'Selecione as empresas',
    },
    buttons: {
      create: 'Criar caixa de entrada',
      edit: 'Editar',
      cancel: 'Cancelar',
      save: 'Salvar',
      saving: 'Salvando...',
    },
    validation: {
      entityRequired: 'Selecione uma empresa.',
      invalidEmail: 'Informe um endereço de e-mail válido.',
      invalidLocalPart: 'Informe um nome de e-mail válido (antes do @).',
      mustIncludeEntityToken: 'Inclua pelo menos um dos termos: {{tokens}}.',
      emailNotUnique: 'Este endereço de e-mail já está em uso.',
      invalidAllowedSender: 'Entrada inválida na lista de remetentes.',
      allowedSendersMax: 'No máximo {{max}} entradas na lista de remetentes.',
      invalidAllowedUrlDomain: 'Domínio inválido na lista de links permitidos.',
      allowedUrlDomainsMax: 'No máximo {{max}} domínios na lista de links permitidos.',
    },
    toasts: {
      created: 'Caixa de entrada criada.',
      updated: 'Caixa de entrada atualizada.',
      saveError: 'Não foi possível salvar a caixa de entrada.',
    },
  },
  labCards: {
    rejectedEmailSenders: {
      title: 'E-mails de remetentes não permitidos',
      description:
        'Algumas mensagens recebidas foram rejeitadas porque o endereço do remetente não está entre os permitidos',
      loadingLabel: 'Carregando e-mails rejeitados…',
      rowNoun: { one: 'e-mail rejeitado', other: 'e-mails rejeitados' },
      badgeUnread: '{{count}} não lidos',
      openList: 'Ver detalhes',
      dialogTitle: 'E-mails de entrada rejeitados',
      onlyUnread: 'Somente não lidos',
      markRead: 'Marcar como lidos',
      markReadError: 'Não foi possível marcar os e-mails como lidos. Tente de novo.',
      loadError: 'Não foi possível carregar o registro de rejeições.',
      empty: 'Nenhuma rejeição registrada.',
      columns: {
        sender: 'Remetente',
        target: 'Caixa de entrada',
        at: 'Quando',
        reason: 'Motivo',
      },
      reasonNotOnAllowList: 'Remetente fora da lista permitida',
      linkSettings: 'Configurar listas em Contexto organização',
    },
  },
  vendorContextUpload: {
    card: {
      title: 'Contexto histórico de fornecedores',
      badge: '{{count}} fornecedores',
      description:
        'Envie classificações históricas por entidade usando CNPJ, CPF ou identificação fiscal estrangeira.',
    },
    fields: {
      entityLabel: 'Entidade',
      fileLabel: 'Arquivo CSV',
      fileHelper: 'Inclua uma coluna de identificação fiscal e as dimensões de classificação.',
      selectedFile: 'Arquivo selecionado: {{fileName}}',
    },
    buttons: {
      upload: 'Enviar CSV',
      uploading: 'Enviando...',
    },
    status: {
      label: 'Status do processamento',
      pending: 'Pendente',
      processing: 'Processando',
      completed: 'Concluído',
      failed: 'Falhou',
      cancelled: 'Cancelado',
    },
    progress: {
      summary: 'Processando {{processed}} de {{total}} fornecedores',
      noTotals: 'Processamento em andamento',
    },
    errors: {
      loadStatus: 'Não foi possível carregar o status do processamento.',
      jobFailed: 'Falha no processamento: {{message}}',
      jobFailedFallback: 'Erro desconhecido.',
      vendorFailures_one: '1 fornecedor falhou durante o processamento.',
      vendorFailures_other: '{{count}} fornecedores falharam durante o processamento.',
    },
    toasts: {
      started: 'Processamento iniciado.',
      uploadError: 'Não foi possível enviar o arquivo.',
      missingFile: 'Selecione um arquivo CSV antes de enviar.',
      missingEntity: 'Selecione uma entidade antes de enviar.',
    },
    skips: {
      summary: '{{count}} linha(s) ignorada(s)',
      emptyTaxId: '{{count}} sem identificação fiscal',
      invalidTaxId: '{{count}} com identificação fiscal inválida',
      unsupportedType: '{{count}} com tipo não suportado',
      missingCountry: '{{count}} sem país',
      invalidCountry: '{{count}} com país inválido',
    },
    mappingDialog: {
      title: 'Mapear colunas do CSV',
      description:
        'Escolha a identificação fiscal, o país e as dimensões que pertencem à entidade selecionada.',
      loading: 'Analisando arquivo CSV...',
      headerColumn: 'Coluna do CSV',
      mappingColumn: 'Campo destino',
      previewColumn: 'Amostra',
      defaults: {
        taxIdType: 'Tipo padrão da identificação',
        country: 'País padrão',
      },
      taxIdTypes: {
        AUTO: 'Detectar CPF ou CNPJ',
        CNPJ: 'CNPJ',
        CPF: 'CPF',
        INTERNATIONAL: 'Identificação internacional',
      },
      fields: {
        taxId: 'Identificação fiscal',
        taxIdType: 'Tipo da identificação',
        countryCode: 'País',
        legalName: 'Razão social do fornecedor',
        glAccountName: 'Conta Contábil',
        managerialAccountName: 'Conta Gerencial',
        costCenterName: 'Centro de Custo',
        departmentName: 'Departamento',
        amount: 'Valor',
        date: 'Data',
        origin: 'Origem / Tipo de Documento',
        skip: 'Ignorar (metadados extras)',
      },
      errors: {
        noTaxId: 'Selecione a coluna de identificação fiscal.',
        internationalCountry: 'Selecione um país estrangeiro ou mapeie uma coluna de país.',
        parse: 'Não foi possível ler o arquivo CSV.',
      },
      duplicateColumns: 'As colunas {{columns}} foram selecionadas mais de uma vez.',
      unmappedHint:
        '{{count}} coluna(s) não mapeada(s) serão armazenadas como metadados extras: {{columns}}',
      buttons: {
        confirm: 'Confirmar e enviar',
        confirming: 'Enviando...',
        cancel: 'Cancelar',
      },
    },
    emptyState: {
      noJob: 'Nenhum processamento em andamento.',
    },
    history: {
      title: 'Histórico de importações',
      selectEntity: 'Selecione uma entidade para consultar as importações.',
      loading: 'Carregando importações...',
      error: 'Não foi possível carregar o histórico de importações.',
      empty: 'Nenhuma importação encontrada.',
      legacy: 'Contexto legado',
      processed: '{{processed}} de {{total}} fornecedores processados',
      pagination: 'Página {{page}} de {{totalPages}}',
      previous: 'Página anterior',
      next: 'Próxima página',
      columns: {
        import: 'Importação',
        entity: 'Entidade',
        status: 'Status',
        result: 'Resultado',
      },
    },
  },
  entityPaymentConfig: {
    title: 'Dias de Pagamento',
    subtitle: 'Configure o dia padrão de vencimento para cada empresa',
    loading: 'Carregando configurações de pagamento...',
    error: 'Não foi possível carregar as configurações de pagamento.',
    toasts: {
      saved: 'Configurações salvas.',
      saveError: 'Não foi possível salvar as configurações.',
    },
    footer: {
      noChanges: 'Nenhuma alteração registrada',
      unsavedChanges: 'Alterações não salvas',
      lastUpdated: 'Atualizado em {{date}}',
    },
    buttons: {
      discard: 'Descartar Alterações',
      save: 'Salvar Configurações',
      saving: 'Salvando...',
    },
    config: {
      card: {
        title: 'Dia padrão de vencimento',
        description:
          'Define o vencimento padrão quando nenhuma data explícita está disponível (ex.: NF sem vencimento).',
      },
      fields: {
        entity: 'Empresa',
        entityPlaceholder: 'Selecione a empresa',
        mode: 'Modo de agendamento',
        modePlaceholder: 'Selecione o modo',
        modeHelp:
          'Dias da semana: escolha um ou mais dias fixos. Dias do mês: escolha um ou mais dias (1–31).',
        days: 'Dias',
        noConfig: 'Sem configuração padrão',
        noConfigHelp: 'Quando não configurado, o sistema usa 30 dias após a emissão como fallback.',
      },
      enums: {
        mode: {
          WEEKDAYS: 'Dias da semana',
          MONTH_DAYS: 'Dias do mês',
        },
        weekdays: {
          '0': 'Dom',
          '1': 'Seg',
          '2': 'Ter',
          '3': 'Qua',
          '4': 'Qui',
          '5': 'Sex',
          '6': 'Sáb',
        },
      },
    },
  },
  entityReimbursementPaymentConfig: {
    title: 'Pagamento de reembolsos',
    subtitle: 'Configure a data prevista de pagamento de reembolsos por empresa',
    loading: 'Carregando configurações de reembolso...',
    error: 'Não foi possível carregar as configurações de reembolso.',
    toasts: {
      saved: 'Configurações de reembolso salvas.',
      saveError: 'Não foi possível salvar as configurações de reembolso.',
    },
    footer: {
      noChanges: 'Nenhuma alteração registrada',
      unsavedChanges: 'Alterações não salvas',
    },
    buttons: {
      discard: 'Descartar Alterações',
      save: 'Salvar Configurações',
      saving: 'Salvando...',
    },
    config: {
      card: {
        title: 'Data prevista de pagamento de reembolso',
        description:
          'Define a regra global da empresa quando a política usa a configuração global.',
      },
      fields: {
        entity: 'Empresa',
        entityPlaceholder: 'Selecione a empresa',
        mode: 'Modo de agendamento',
        modePlaceholder: 'Selecione o modo',
        modeHelp: 'Escolha dias fixos ou um prazo relativo ao envio/aprovação.',
        days: 'Dias',
        offsetDays: 'D+n dias',
        anchor: 'Âncora',
        noConfig: 'Sem configuração global',
        noConfigHelp: 'Quando não configurado, o sistema usa D+7 após o envio.',
      },
      enums: {
        mode: {
          WEEKDAYS: 'Dias da semana',
          MONTH_DAYS: 'Dias do mês',
          OFFSET_DAYS: 'D+n dias',
        },
        anchor: {
          SUBMISSION: 'Após envio',
          APPROVAL: 'Após aprovação',
        },
        weekdays: {
          '0': 'Dom',
          '1': 'Seg',
          '2': 'Ter',
          '3': 'Qua',
          '4': 'Qui',
          '5': 'Sex',
          '6': 'Sáb',
        },
      },
    },
  },
  // ALC-1504: per-entity statutory treatment. The copy has to explain WHY the choice exists, since
  // getting it wrong silently bypasses a tax liability that nothing credited.
  statutoryTreatment: {
    title: 'Tratamento de guias de impostos',
    subtitle: 'Define, por entidade, como cada tributo é classificado e contabilizado na aprovação',
    entity: 'Entidade',
    entityPlaceholder: 'Selecione a entidade',
    loading: 'Carregando tributos...',
    unavailable: {
      title: 'Configuração indisponível para esta norma contábil',
      description:
        'O tratamento de guias baseado nos pronunciamentos CPC está disponível somente para entidades com ao menos um livro na norma BR_CPC. Normas desta entidade: {{frameworks}}.',
      noBooks: 'nenhum livro contábil associado',
    },
    card: {
      title: 'Tratamento por tributo',
      description: 'Como tratar o provisionamento do imposto no Contas a Pagar.',
    },
    columns: {
      slot: 'Tributo',
      treatment: 'Tratamento',
      treatmentInfo: 'Entenda como escolher o tratamento',
      source: 'Origem',
      actions: '',
    },
    modes: {
      BYPASS: 'Usar passivo de origem',
      AUTO_PROVISION: 'Provisionamento automático',
      CLASSIFY: 'Classificar',
    },
    modeDescriptions: {
      BYPASS:
        'Exige passivo reconhecido pelo evento legal; a guia apenas reclassifica origens válidas e bloqueia quando o produtor ainda não existe.',
      AUTO_PROVISION:
        'Transfere o principal de Apurado para Em Guias a Pagar na aprovação, mesmo que Apurado fique com saldo negativo.',
      CLASSIFY: 'Exige classificação contábil antes da aprovação da guia.',
    },
    categories: {
      WITHHOLDING_AP: 'Retenções sobre fornecedores',
      OWN_AR: 'Tributos próprios',
      PAYROLL: 'Folha de pagamento',
      DEDUCTION: 'Deduções de receita',
      RECOVERABLE: 'Tributos a recuperar',
      TAX_EXPENSE: 'Despesas tributárias',
    },
    source: {
      configured: 'Configurado',
      default: 'Padrão ({{treatment}})',
    },
    actions: {
      reset: 'Voltar ao padrão',
    },
    noAutoProvisionShort: 'sem contrapartida',
    noAutoProvisionReason:
      'Este tributo não tem conta de contrapartida definida para provisionamento na aprovação da guia.',
    toast: {
      saved: 'Tratamento atualizado',
      reset: 'Tratamento voltou ao padrão',
      error: 'Não foi possível salvar: {{message}}',
    },
  },
  fiscalRegimeAliquotas: {
    title: 'Regime & Alíquotas',
    subtitle: 'Configure parâmetros fiscais por empresa',
    loading: 'Carregando configurações fiscais...',
    error: 'Não foi possível carregar as configurações fiscais.',
    toasts: {
      saved: 'Configurações salvas.',
      saveError: 'Não foi possível salvar as configurações.',
    },
    footer: {
      noChanges: 'Nenhuma alteração registrada',
      lastUpdated: 'Atualizado em {{date}}',
    },
    buttons: {
      discard: 'Descartar Alterações',
      save: 'Salvar Configurações',
      saving: 'Salvando...',
    },
    successor: {
      action: 'Iniciar nova vigência fiscal',
      title: 'Nova vigência fiscal',
      description:
        'Registre a mudança do contribuinte com a data e a evidência que sustentam o novo regime.',
      loading: 'Carregando o histórico fiscal...',
      loadError: 'Não foi possível carregar o histórico fiscal. Tente novamente.',
      activePeriodRequired:
        'O contribuinte precisa ter exatamente uma vigência fiscal ativa antes de iniciar a sucessora.',
      currentPeriod: 'Vigência ativa desde {{from}}.',
      validFrom: 'Início da nova vigência',
      validFromPlaceholder: 'dd/mm/aaaa',
      validFromHelp: 'Informe o primeiro dia do mês em que a mudança produz efeitos.',
      validFromError: 'Informe o primeiro dia de um mês posterior ao início da vigência atual.',
      companyTaxRegime: 'Novo regime tributário',
      pisCofinsRegime: 'Novo regime PIS/COFINS',
      dueBasis: 'Novo regime de reconhecimento',
      dueBasisAccrual: 'Competência',
      dueBasisCash: 'Caixa',
      exceptionReason: 'Motivo legal da mudança no ano',
      exceptionPlaceholder: 'Selecione o motivo',
      exception: {
        START_OF_ACTIVITY: 'Início de atividade',
        MANDATORY_LUCRO_REAL: 'Enquadramento obrigatório no Lucro Real',
        OTHER_WITH_EVIDENCE: 'Outro motivo com evidência',
      },
      evidenceCode: 'Código da evidência',
      evidenceDescription: 'Descrição da evidência',
      warningTitle: 'Revise os avisos antes de confirmar',
      confirmation:
        'Confirmo a vigência, os regimes e a evidência informados e reconheço os avisos fiscais desta mudança.',
      saveOrDiscardFirst:
        'Salve ou descarte as alterações do formulário antes de iniciar uma nova vigência fiscal.',
      save: 'Iniciar vigência',
      confirmWarnings: 'Confirmar e iniciar vigência',
      cancel: 'Cancelar',
      error: 'Não foi possível iniciar a nova vigência fiscal.',
    },
    config: {
      card: {
        title: 'Configuração da empresa',
        description:
          'Defina o regime e parâmetros usados no cálculo/validação de retenções por empresa.',
      },
      fields: {
        entity: 'Empresa',
        entityPlaceholder: 'Selecione a empresa',
        companyTaxRegime: 'Regime tributário',
        companyTaxRegimePlaceholder: 'Selecione o regime',
        pisCofinsRegime: 'Regime PIS/COFINS',
        pisCofinsRegimePlaceholder: 'Selecione o regime',
        pisCofinsRegimeDisabledHelp:
          'PIS/COFINS não aplicável para Simples Nacional (incluído no DAS).',
        pisCofinsRegimeLockedHelp: 'Regime fixo em Cumulativo para Lucro Presumido.',
        defaultPisRate: 'Alíquota PIS (padrão)',
        defaultCofinsRate: 'Alíquota COFINS (padrão)',
        irrfMinimumAmount: 'Retenção IRRF (Valor mínimo)',
        irrfMinimumAmountHelp:
          'Valor mínimo de IRRF para retenção, avaliado por pagamento. Se o imposto calculado for igual ou inferior a este valor, a retenção é dispensada (Art. 67, Lei 9.430/96). Não há acumulação entre notas.',
        defaultIssMunicipality: 'Município padrão NFS-e',
        defaultIssMunicipalityHelp:
          'Município IBGE usado por padrão na emissão de NFS-e da empresa. Os serviços podem sobrescrever esse valor.',
        defaultIssMunicipalityPlaceholder: 'Digite para buscar na Focus NFe',
        autoCalculateWithholdings: 'Calcular retenções automaticamente',
        autoCalculateWithholdingsHelp:
          'Sugere valores com base em regras fiscais do tipo de serviço.',
        requireWithholdingConfirmation: 'Exigir confirmação de retenções',
        requireWithholdingConfirmationHelp: 'Força validação manual antes de finalizar.',
        takeCreditFromSimples: 'Permitir crédito para Simples',
        takeCreditFromSimplesHelp: 'Habilita crédito presumido quando aplicável.',
        simplesDefaultCreditRate: 'Alíquota de crédito (Simples)',
        simplesDefaultCreditRatePlaceholder: 'Ex.: 0.02',
      },
      // Labels and helper lines of the Entities page tab (the create dialog keeps `fields`).
      sections: {
        optional: 'opcional',
        pisRate: 'PIS (padrão)',
        cofinsRate: 'COFINS (padrão)',
        // The help of this field is `fields.irrfMinimumAmountHelp` (decision I53): one text, the
        // long one with the legal reference, in the tooltip and in the stacked layout.
        irrfMinimum: 'Retenção IRRF (valor mínimo)',
        municipalityHelp: 'Cada serviço pode sobrescrever esse município.',
        autoCalculateWithholdingsHelp:
          'Sugere IRRF, CSRF, INSS e ISS em cada conta a pagar com base no fornecedor e no serviço.',
      },
      groups: {
        regime: {
          title: 'Regime',
          subtitle: 'Como a empresa é tributada e como PIS e COFINS são apurados.',
        },
        rates: {
          title: 'Alíquotas',
          subtitle: 'Alíquotas padrão de PIS e COFINS e o valor mínimo para reter IRRF.',
        },
        nfse: {
          title: 'NFS-e',
          subtitle: 'Município usado por padrão na emissão de notas de serviço.',
        },
        withholdings: {
          title: 'Retenções e créditos',
          subtitle: 'Como as retenções são sugeridas e confirmadas, e o crédito do Simples.',
        },
      },
      enums: {
        companyTaxRegime: {
          SIMPLES_NACIONAL: 'Simples Nacional',
          LUCRO_PRESUMIDO: 'Lucro Presumido',
          LUCRO_REAL: 'Lucro Real',
        },
        pisCofinsRegime: {
          CUMULATIVE: 'Cumulativo',
          NON_CUMULATIVE: 'Não cumulativo',
        },
      },
    },
  },
  fiscalAccountMapping: {
    title: 'Mapeamento Contábil',
    subtitle: 'Vincule slots fiscais às contas contábeis do plano ativo',
    loading: 'Carregando configurações fiscais...',
    error: 'Não foi possível carregar as configurações fiscais.',
    toasts: {
      saved: 'Configurações salvas.',
      saveError: 'Não foi possível salvar as configurações.',
      rootScopeGlobal:
        'As contas raiz são configurações globais. Limpe o escopo de entidade/livro antes de salvá-las.',
      createAccountError: 'Não foi possível criar a conta contábil.',
      aiSuggestSuccess_one: '1 sugestão aplicada',
      aiSuggestSuccess_other: '{{count}} sugestões aplicadas',
      aiSuggestEmpty: 'Todos os slots já estão mapeados ou nenhuma sugestão encontrada',
      aiSuggestError: 'Não foi possível sugerir contas. Tente novamente.',
    },
    footer: {
      noChanges: 'Nenhuma alteração registrada',
      lastUpdated: 'Atualizado em {{date}}',
    },
    buttons: {
      discard: 'Descartar Alterações',
      save: 'Salvar Configurações',
      saving: 'Salvando...',
      aiSuggest: 'Transmutar contas',
      aiSuggesting: 'Transmutando...',
    },
    requiredForAll: 'Obrigatório para todos os regimes',
    requiredForRegimes: 'Obrigatório para: {{regimes}}',
    mappings: {
      card: {
        title: 'Mapeamento fiscal → contas contábeis',
        description:
          'Vincule cada slot fiscal a uma conta lançável do plano de contas ativo. Você pode criar contas diretamente aqui.',
      },
      required: 'Obrigatório',
      missingRequired: '{{count}} obrigatório(s) pendente(s)',
      allRequiredMapped: 'Obrigatórios ok',
      noActiveVersion: 'Nenhuma versão ativa do plano de contas (APPLIED) encontrada.',
      createAccount: 'Criar conta',
      accountPlaceholder: 'Buscar conta...',
      clear: 'Limpar',
      jurisdictionCategory: '{{jurisdiction}} • {{category}}',
      categories: {
        WITHHOLDING_AP: {
          name: 'Retenções a pagar',
          description: 'Impostos retidos de fornecedores (PIS, COFINS, CSLL, INSS, ISS)',
        },
        OWN_AR: {
          name: 'Próprios a recolher',
          description: 'Impostos próprios da empresa (PIS, COFINS, IPI, IRPJ, CSLL, ISS)',
        },
        DEDUCTION: {
          name: 'Deduções de receita',
          description: 'Reduções no resultado (PIS, COFINS, ISS sobre receita)',
        },
        TAX_EXPENSE: {
          name: 'Despesas fiscais',
          description:
            'Multas e juros sobre tributos e provisões de imposto sobre o lucro (IRPJ, CSLL)',
        },
        RECOVERABLE: {
          name: 'A recuperar',
          description: 'Créditos recuperáveis (PIS, COFINS, IRRF, retenções sofridas)',
        },
        PAYROLL: {
          name: 'Folha de pagamento',
          description: 'Impostos sobre salários (INSS, FGTS, IRRF sobre rendimentos)',
        },
      },
    },
  },
  accountMapping: {
    selectionWarning: {
      type: 'A conta {{code}} é {{actualType}} ({{actualNature}}). Este campo exige {{expectedType}} ({{expectedNature}}). Selecione uma conta compatível ou revise seu cadastro no plano de contas.',
      managed:
        'A conta {{code}} é gerenciada pelo tributo {{owner}} e não pode ser selecionada diretamente neste campo. Revise o compartilhamento no fluxo de configuração do passivo tributário.',
      inactive:
        'A conta {{code}} está inativa. Ative-a no plano de contas ou selecione outra conta.',
      nonPostable:
        'A conta {{code}} não aceita lançamentos diretos. Selecione uma conta que aceite lançamentos.',
      unavailable:
        'A conta {{code}} não está entre as opções permitidas para este campo. Revise o mapeamento ou selecione outra conta.',
    },
    title: 'Mapeamentos',
    subtitle: 'Configure contas raiz, slots do sistema e slots fiscais em um único lugar',
    loading: 'Carregando mapeamento...',
    error: 'Não foi possível carregar o mapeamento.',
    scope: {
      title: 'Escopo do plano de contas',
      description:
        'As contas, sugestões e mapeamentos abaixo usam a versão ativa para esta entidade/livro.',
      entityLabel: 'Entidade',
      bookLabel: 'Livro',
      activeVersion: 'Versão ativa: {{version}}',
      selectScope: 'Selecione uma entidade para carregar os mapeamentos.',
      resolveError: 'Não foi possível resolver a versão ativa: {{message}}',
    },
    cashLayer: {
      title: 'Uso da conta raiz',
      description:
        'Escolha se bancos, investimentos e cartões desta entidade usam a conta raiz da tabela ou uma conta analítica no cadastro.',
      switchLabel: 'Exigir conta analítica no cadastro',
      directDescription:
        'No cadastro, a única escolha é uma conta analítica já existente. A conta raiz só é escolhida neste mapeamento. Sem ela, o lançamento não é contabilizado até você selecioná-la.',
      rootDescription:
        'Mapeie a conta raiz na linha abaixo. No primeiro lançamento, o sistema cria uma conta analítica sob essa raiz.',
      slots: {
        OP_BANK_ACCOUNT: 'Contas bancárias',
        OP_INVESTMENT_SHORT_TERM: 'Contas de investimento',
        OP_CREDIT_CARD: 'Cartões de crédito',
      },
      rootHints: {
        OP_BANK_ACCOUNT:
          'Os lançamentos desta entidade não usam esta conta raiz. Vincule a conta analítica em cada conta bancária, no menu Caixa, em Contas bancárias.',
        OP_INVESTMENT_SHORT_TERM:
          'Os lançamentos desta entidade não usam esta conta raiz. Vincule a conta analítica em cada conta de investimento, no menu Caixa, em Contas bancárias.',
        OP_CREDIT_CARD:
          'Os lançamentos desta entidade não usam esta conta raiz. Vincule a conta analítica em cada cartão, no menu Caixa, em Cartões de crédito.',
      },
      saved: 'Uso da conta raiz salvo.',
      loading: 'Carregando o uso da conta raiz',
      loadError: 'Não foi possível carregar o uso da conta raiz.',
      errors: {
        linksOutsideRoot:
          'Não é possível voltar a usar a conta raiz: há cadastros vinculados a contas fora dela. Vincule-os a contas sob a raiz e tente outra vez.',
        generic: 'Não foi possível salvar a configuração. Tente novamente.',
      },
    },
    loader: {
      title: 'Analisando mapeamentos...',
      subtitle: 'Isso pode levar até 1 minuto. Não feche ou atualize a página.',
      processing: 'Em processamento',
      completed: 'Concluído',
      dismiss: 'Fechar',
      labels: {
        stage1: 'Extraindo o minério…',
        stage2: 'Fundindo a matéria…',
        stage3: 'Purificando a forma…',
        stage4: 'Refinando as arestas…',
        stage5: 'Transmutando em ouro…',
      },
    },
    tabs: {
      setupTotal: '{{setup}}/{{total}}',
      ROOT: 'Contas Raiz',
      AP: 'Contas a pagar',
      AR: 'Contas a receber',
      GL: 'Contabilidade',
      HCM: 'Pessoas',
      OP: 'Tesouraria',
      FISCAL: 'Fiscal',
      FA: 'Ativos',
    },
    rfbReference: {
      code: 'RFB · {{code}}',
      unverified: 'RFB · Sem referência validada',
      openSource: 'Referência RFB {{code}} — abrir fonte oficial em nova aba',
      scope:
        'ECF, leiaute {{layout}}: ano-calendário 2025 e situações especiais de 2026. Empresas em geral, lucro real ou presumido.',
      rows: 'Planilhas e linhas: {{rows}}',
      status: {
        VERIFIED_FAMILY:
          'Família referencial sugerida para este tributo. Não substitui a conta contábil da empresa.',
        CONDITIONAL_FAMILY:
          'Referência indicativa: confirme a operação, o regime e o direito ao crédito antes de aplicar.',
        LEGACY_CONTEXT_REQUIRED:
          'Mapeamento legado: confirme a hipótese legal de retenção antes de usar esta referência.',
        POLICY_REQUIRED:
          'Não há referência específica validada no catálogo para este tributo. Requer análise contábil.',
      },
    },
    table: {
      settingName: 'Configuração',
      slotName: 'Slot',
      category: 'Categoria',
      accountType: 'Tipo conta',
      description: 'Descrição',
      glAccount: 'Conta contábil',
      actions: 'Ações',
      accountPlaceholder: 'Buscar conta...',
      clear: 'Limpar',
      createAccount: 'Criar conta',
      invalidTaxAccount: '{{code}}: tipo ou natureza incompatível com este tributo.',
      invalidIncomeTaxAccount: '{{code}}: selecione ou crie uma conta de despesa não operacional.',
      aiCreateSuggestion: 'Sugestão da IA',
      // Distinguishes a MAP suggestion (an account already picked by the AI, pending the user's
      // confirmation) from a saved mapping — the Wand2 icon alone reads the same either way
      // (Bug 032).
      aiMapSuggestion: 'Sugestão da IA — ainda não salva',
      managedByTaxRail:
        'Gerenciado pela estrutura fiscal de {{slotCode}}. Os saldos permanecem separados por tributo.',
      provisionVacationMappedToPayable:
        'Conta de férias a pagar mapeada; a folha espera a conta de provisão.',
      provisionThirteenthMappedToPayable:
        'Conta de 13º salário a pagar mapeada; a folha espera a conta de provisão.',
    },
    toasts: {
      saved: 'Configurações salvas.',
      railsConfigured: 'Régua(s) fiscal(is) configurada(s).',
      saveError: 'Não foi possível salvar as configurações.',
      railAccountClaimed:
        'A estrutura da conta {{accountCode}} é incompatível com este vínculo. Revise a configuração contábil.',
      createAccountError: 'Não foi possível criar a conta contábil.',
      aiSuggestSuccess_one: '1 sugestão aplicada',
      aiSuggestSuccess_other: '{{count}} sugestões aplicadas',
      aiSuggestEmpty: 'Todos os slots já estão mapeados ou nenhuma sugestão encontrada',
      aiSuggestError: 'Não foi possível sugerir contas. Tente novamente.',
    },
    fpaRemap: {
      title: 'Este vínculo altera a DRE do FP&A',
      description:
        'Os slots fiscais alterados entram em rollups contábeis do FP&A. Confirmar aplica o novo vínculo à composição da DRE — inclusive em períodos já avaliados ao vivo.',
      canApply:
        'Você tem permissão de FP&A (fpa:manage). Confirme apenas se também quiser atualizar os rollups da DRE.',
      needsPermission:
        'Você não tem permissão de FP&A (fpa:manage). Peça a alguém com essa permissão para aplicar o vínculo aos rollups, ou salve só o mapeamento fiscal depois que o FP&A for atualizado.',
      cancel: 'Cancelar',
      confirm: 'Aplicar também ao FP&A',
    },
    railRepair: {
      notice:
        'Este imposto não está configurado. A conta {{accountCode}} é uma conta de grupo e não recebe lançamentos, então a aprovação de contas a pagar com este imposto falha.',
      action: 'Configurar estrutura fiscal',
      title: 'Configurar estrutura fiscal',
      description:
        '{{taxName}} usa a conta de grupo {{accountCode}} {{accountName}}. Escolha qual conta filha recebe cada etapa do imposto.',
      apuradoLabel: 'Apurado',
      apuradoHelp: 'Recebe o imposto retido quando uma conta a pagar é aprovada.',
      guidesLabel: 'Em guias a pagar',
      guidesHelp: 'Recebe o imposto quando ele entra numa guia (DARF) aprovada, até o pagamento.',
      placeholder: 'Escolha uma conta filha',
      samePick: 'Escolha uma conta diferente da etapa Apurado.',
      sharedTaxes: 'Também passa a usar esta estrutura: {{taxes}}.',
      noJournal: 'Nenhum lançamento é criado. Os saldos atuais ficam onde estão.',
      cancel: 'Cancelar',
      confirm: 'Configurar estrutura',
      success: 'Estrutura fiscal configurada.',
      successDetail:
        'As contas a pagar com {{taxes}} já podem ser aprovadas. Os lançamentos antigos ficam na conta {{accountCode}}.',
      close: 'Fechar',
      billToastTitle: 'O imposto {{taxName}} não está configurado.',
      billToastDescription: 'Configure a estrutura fiscal para aprovar esta conta a pagar.',
      billToastDescriptionNoAccess:
        'Peça a quem gerencia as configurações para configurar a estrutura fiscal deste imposto.',
      billToastAction: 'Configurar',
    },
    // Mensagens por código de erro do backend. Os textos do servidor são voltados a
    // desenvolvedores (em inglês, citando endpoints); estas explicam o que aconteceu e o que
    // fazer em seguida.
    railErrors: {
      TAX_RAIL_ALIAS_OUTSIDE_RAIL:
        'Este tributo já tem uma conta vinculada à folha. Selecione essa conta ou a conta principal da mesma estrutura. Para usar outra, é necessária uma migração contábil dos saldos.',
      TAX_LIABILITY_RAIL_ACCOUNT_ALREADY_CLAIMED:
        'A estrutura da conta {{accountCode}} é incompatível com {{taxName}}. Revise a configuração contábil.',
      TAX_LIABILITY_RAIL_MAPPING_CONFLICT:
        'Este tributo já usa a conta gerenciada "{{accountName}}". As contas "Apurado" e "Em Guias a Pagar" são movimentadas automaticamente pelo sistema e não podem ser escolhidas aqui — selecione a conta principal.',
      TAX_LIABILITY_RAIL_APPLIED_REMAP_FORBIDDEN:
        'Este tributo já está mapeado em um plano de contas aplicado, com lançamentos históricos na conta atual. Selecione a conta já mapeada para convertê-la em conta gerenciada; apontar para outra conta abandonaria os saldos existentes.',
      TAX_LIABILITY_RAIL_LIVE_REMAP_FORBIDDEN:
        'Este tributo já possui lançamentos no plano de contas vigente. Mantenha a conta atualmente mapeada para convertê-la em conta gerenciada; não é possível trocá-la por outra conta.',
      TAX_LIABILITY_RAIL_SUPERSEDED_REMAP_FORBIDDEN:
        'Este plano de contas foi substituído e guarda histórico fiscal. Faça o mapeamento no plano vigente; o vínculo histórico deste tributo não pode ser alterado.',
      selectedAccount: 'conta selecionada',
      selectedTax: 'Mapeamento fiscal',
      unknownAccountType: 'tipo incompatível',
      unknownBalance: 'não identificada',
      accountTypes: {
        ASSET: 'ativo',
        LIABILITY: 'passivo',
        EQUITY: 'patrimônio líquido',
        REVENUE: 'receita',
        COGS: 'custo',
        EXPENSE: 'despesa',
        OTHER_EXPENSE: 'outras despesas',
        OTHER_INCOME: 'outras receitas',
      },
      balances: { DEBIT: 'devedora', CREDIT: 'credora' },
      TAX_LIABILITY_RAIL_PARENT_INVALID_ACCOUNT_TYPE:
        '{{taxName}}: a conta "{{accountName}}" está cadastrada como {{accountType}}, de natureza {{naturalBalance}}. Este mapeamento exige passivo de natureza credora. Escolha outra conta ou revise o cadastro no plano de contas.',
      TAX_LIABILITY_RAIL_PARENT_INVALID_NATURAL_BALANCE:
        '{{taxName}}: a conta "{{accountName}}" é de natureza devedora; este mapeamento exige natureza credora. Escolha outra conta ou revise o cadastro no plano de contas.',
      TAX_LIABILITY_RAIL_PARENT_INVALID_INACTIVE:
        '{{taxName}}: a conta "{{accountName}}" está inativa. Ative-a no plano de contas ou escolha outra conta.',
      TAX_LIABILITY_RAIL_PARENT_INVALID_NOT_POSTABLE:
        '{{taxName}}: a conta "{{accountName}}" não aceita lançamentos diretos. Selecione uma conta que aceite lançamentos.',
      TAX_LIABILITY_RAIL_PARENT_INVALID_WRONG_VERSION:
        '{{taxName}}: a conta "{{accountName}}" pertence a outro plano de contas. Selecione uma conta deste plano.',
      TAX_LIABILITY_RAIL_PARENT_INVALID_NOT_FOUND:
        '{{taxName}}: a conta selecionada não foi encontrada. Atualize a lista e escolha outra conta.',
      TAX_LIABILITY_RAIL_PARENT_INVALID_SLOT_NOT_ELIGIBLE:
        '{{taxName}} não usa divisão em estágios. Salve pelo mapeamento fiscal comum.',
      TAX_LIABILITY_RAIL_PARENT_INVALID:
        'Não foi possível mapear {{taxName}} na conta "{{accountName}}". Selecione um passivo ativo, de natureza credora e que aceite lançamentos neste plano.',
      TAX_LIABILITY_RAIL_SLOT_NOT_ELIGIBLE:
        'Este tributo não é recolhido por guia, portanto não usa contas gerenciadas em etapas.',
      TAX_LIABILITY_RAIL_DUPLICATE_SLOT:
        'O mesmo tributo foi informado mais de uma vez. Atualize a página e tente novamente.',
      TAX_LIABILITY_RAIL_CONFIGURATION_INVALID:
        'Não foi possível concluir a configuração das réguas fiscais. Revise os mapeamentos dos tributos e tente novamente.',
      TAX_LIABILITY_RAIL_MIGRATION_FLOW_REQUIRED:
        'Tributos recolhidos por guia são alterados pelo fluxo de migração, que confirma o saldo, valida o período aberto e gera o lançamento contábil na mesma operação. Para trocar a conta, selecione a nova conta neste tributo e salve. Remover o mapeamento ainda não é suportado — procure o time contábil.',
      TAX_LIABILITY_RAIL_MIGRATION_CONFIRMATION_REQUIRED:
        'Há saldos tributários que precisam ser confirmados antes da migração. Revise as datas e os períodos de apuração informados.',
      TAX_LIABILITY_RAIL_MIGRATION_EFFECTIVE_DATE_REQUIRED:
        'Informe uma data efetiva para cada saldo tributário que será migrado.',
      TAX_LIABILITY_RAIL_MIGRATION_ASSESSMENT_PERIOD_REQUIRED:
        'Informe um período de apuração válido para cada saldo tributário que será migrado.',
      TAX_LIABILITY_RAIL_MIGRATION_OPEN_PERIOD_REQUIRED:
        'A data efetiva precisa estar em um período contábil aberto. Escolha uma data válida e tente novamente.',
      TAX_LIABILITY_RAIL_MIGRATION_DEBIT_BALANCE:
        'Foi encontrado um saldo devedor em uma conta de tributo. Esse saldo precisa de revisão contábil antes da migração.',
      TAX_LIABILITY_RAIL_DEBIT_BALANCE:
        'Foi encontrado um saldo devedor em uma conta de tributo. Esse saldo precisa de revisão contábil antes da migração.',
      TAX_LIABILITY_RAIL_MIGRATION_EFFECTIVE_DATE_BALANCE_MISMATCH:
        'Não foi possível migrar {{taxName}}: em {{effectiveDate}}, o saldo encontrado é {{effectiveDateAmount}}, mas o saldo Legado a migrar é {{currentBalance}}. Use a data efetiva {{suggestedEffectiveDate}} e o período de apuração {{suggestedAssessmentPeriod}}.',
      balanceMismatchNoSuggestedDate: 'uma data do período aberto que contenha o saldo Legado',
      TAX_RAIL_SLOT_MAPPING_INVALID:
        'O mapeamento deste tributo não aponta para uma conta de passivo válida. Escolha uma conta contábil ativa, credora e que aceite lançamentos.',
      TAX_RAIL_FRAMEWORK_MISMATCH:
        'As réguas fiscais estão disponíveis apenas para livros contábeis do framework BR CPC.',
      TAX_RAIL_BR_CPC_ONLY:
        'As réguas fiscais estão disponíveis apenas para livros contábeis do framework BR CPC.',
      TAX_RAIL_REQUIRES_BR_CPC_BOOK:
        'As réguas fiscais estão disponíveis apenas para livros contábeis do framework BR CPC.',
      TAX_RAIL_BOOK_SCOPE_MISMATCH:
        'A conta e o livro contábil selecionados precisam pertencer ao mesmo escopo. Revise o mapeamento e tente novamente.',
      TAX_RAIL_MIXED_FRAMEWORK_VERSION:
        'Esta versão do plano de contas é compartilhada com um livro de outro framework e não pode usar réguas fiscais BR CPC.',
      TAX_RAIL_SLOT_NOT_ENABLED:
        'Este tributo não está habilitado para usar uma régua fiscal neste plano de contas.',
      TAX_RAIL_CONFIGURATION_INVALID:
        'Não foi possível configurar a régua fiscal. Revise o mapeamento do tributo e tente novamente.',
      TAX_LIABILITY_RAIL_MAPPING_CONFLICT_UNKNOWN:
        'Este tributo já usa uma conta gerenciada. As contas "Apurado" e "Em Guias a Pagar" são movimentadas automaticamente pelo sistema e não podem ser escolhidas aqui — selecione a conta principal.',
      TAX_LIABILITY_RAIL_MAPPING_INVALID:
        'Não foi possível configurar a conta gerenciada deste tributo. Revise a conta selecionada e tente novamente.',
      TAX_LIABILITY_RAIL_SETUP_REQUIRED:
        'O imposto {{taxName}} não está configurado. A conta {{accountCode}} é uma conta de grupo e não recebe lançamentos. Configure a estrutura fiscal.',
      TAX_LIABILITY_RAIL_REPAIR_ACCOUNTS_INVALID:
        'As contas escolhidas não são as duas contas filhas da conta de grupo. Escolha uma conta filha diferente para cada etapa.',
      TAX_LIABILITY_RAIL_REPAIR_SCOPE_REQUIRED:
        'Você não tem acesso a todos os dados contábeis que esta configuração afeta. Peça a alguém com acesso a todas as empresas deste plano de contas.',
      TAX_LIABILITY_RAIL_REPAIR_STALE:
        'Os impostos que usam esta conta de grupo mudaram. Feche esta janela e abra a configuração de novo.',
      TAX_RAIL_GUIDES_BALANCE_NOT_ZERO:
        'A conta escolhida para Em guias a pagar já tem saldo. Esta etapa precisa começar sem saldo. Escolha outra conta filha.',
      TAX_RAIL_STAGED_ACCOUNTS_UNUSABLE:
        'A estrutura fiscal desta conta de grupo está incompleta ou tem uma conta inativa. Revise as contas no plano de contas.',
      TAX_RAIL_COA_VERSION_NOT_FOUND:
        'O plano de contas não foi encontrado. Atualize a página e tente novamente.',
      TAX_RAIL_COA_VERSION_NOT_ENSURABLE:
        'Este plano de contas foi substituído. Configure a estrutura fiscal no plano vigente.',
      TAX_RAIL_SLOT_NOT_ELIGIBLE:
        'Este tributo não é recolhido por guia, portanto não usa contas gerenciadas em etapas.',
      STAGED_TAX_RAIL_FRAMEWORK_MISMATCH:
        'As réguas fiscais estão disponíveis apenas para livros contábeis do framework BR CPC.',
      fallback: 'Não foi possível salvar o mapeamento deste tributo.',
    },
    railMigration: {
      title: 'Confirmar migração do saldo tributário',
      description:
        'A conta mapeada será preservada como Legado (mesmo UUID). O sistema debitará o saldo em Legado e creditará Apurado para cada tributo abaixo. Informe o período de apuração estatutário de cada saldo — a data efetiva do lançamento não o substitui.',
      tax: 'Tributo',
      account: 'Conta Legado',
      entity: 'Entidade',
      book: 'Livro',
      balance: 'Saldo a migrar',
      scope: 'Dados do lançamento',
      scopeDescription: 'Entidade {{entity}} · Livro {{book}}',
      entityBook: 'Entidade {{entityId}} · Livro {{bookId}}',
      effectiveDate: 'Data efetiva',
      assessmentPeriod: 'Período de apuração',
      effectiveDateRequired: 'Informe uma data efetiva para cada saldo migrado.',
      assessmentPeriodRequired: 'Informe o período de apuração (mês/ano) para cada saldo migrado.',
      confirmation:
        'Confirmo a reclassificação dos saldos de Legado para Apurado com os períodos de apuração informados.',
      confirm: 'Confirmar e registrar lançamento',
      confirming: 'Registrando lançamento...',
      processingTitle: 'Registrando migração',
      processingDescription: 'As réguas fiscais e os lançamentos estão sendo criados.',
      processingBody: 'Aguarde enquanto concluímos a migração. Não feche esta janela.',
      cancel: 'Cancelar',
      close: 'Fechar',
      retry: 'Tentar novamente',
      successTitle: 'Migração registrada',
      successDescription: 'As réguas fiscais e os lançamentos de reclassificação foram criados.',
      successBody: 'Você já pode voltar à configuração fiscal ou aprovar o RPA.',
      errorTitle: 'Não foi possível registrar a migração',
      errorDescription:
        'Nenhuma régua ou lançamento foi criado. Corrija o problema indicado e tente novamente.',
    },
    footer: {
      noChanges: 'Nenhuma alteração registrada',
      lastUpdated: 'Atualizado em {{date}}',
      unsavedChanges: 'Alterações não salvas',
    },
    buttons: {
      discard: 'Descartar Alterações',
      // This is the PLAIN save button (calls `handleSave`) — it commits whatever is already
      // filled in, AI-suggested or not. "Salvar Configurações" read as a generic settings save
      // and, worse, was easy to swap in a reviewer's head with `acceptSuggestions` below, which
      // is the AI-suggestions button — that mix-up misled two reviewers in a row (Bug 031-b).
      save: 'Salvar mapeamentos',
      saving: 'Salvando...',
      configureMappedRails_one: 'Configurar 1 régua fiscal',
      configureMappedRails_other: 'Configurar {{count}} réguas fiscais',
      configuringRails: 'Configurando réguas...',
      configureMappedRailsHelp:
        'Cria automaticamente as réguas fiscais ainda ausentes para as contas já mapeadas.',
      configureMappedRailsSaveFirst:
        'Salve as alterações de mapeamento antes de configurar as réguas fiscais.',
      aiSuggest: 'Analisar e sugerir contas',
      aiSuggestAgain: 'Pedir novas sugestões',
      aiSuggesting: 'Analisando...',
      aiSuggestingWarning: 'Analisando contas, por favor permaneça nesta página...',
      // This is the ACCEPT-AI-SUGGESTIONS button (calls `saveAllDrafts`) — it only shows up when
      // there are pending AI suggestions to confirm. Naming it "Salvar mapeamentos" on a screen
      // whose whole job is mappings made it indistinguishable from the plain save button above.
      acceptSuggestions: 'Aceitar sugestões',
      acceptAndCreate: 'Salvar mapeamentos e criar contas',
      acceptingAndCreating: 'Criando contas...',
      discardHelp: 'Descarta alterações desta aba sem salvar.',
      saveMappingsHelp: 'Salva apenas os mapeamentos já preenchidos na coluna "Conta contábil".',
      saveAndCreateHelp:
        'Salva os mapeamentos e cria as novas contas contábeis sugeridas pela Alchemy.',
    },
    bulkCreateConfirm: {
      title: 'Confirmar criação de contas',
      description: 'Revise e edite as contas que serão criadas com base nas sugestões da IA.',
      table: {
        slotName: 'Slot',
        accountName: 'Nome da conta',
        accountCode: 'Código da conta',
        parentCode: 'Código pai',
        parentPlaceholder: 'Selecione conta pai...',
        accountType: 'Tipo',
        naturalBalance: 'Saldo natural',
        actions: 'Ações',
      },
      buttons: {
        confirm: 'Confirmar e criar contas',
        cancel: 'Cancelar',
        confirming: 'Criando contas...',
        remove: 'Remover',
      },
      empty: 'Nenhuma conta para criar.',
      validation: {
        nameRequired: 'Nome da conta é obrigatório',
        codeRequired: 'Código da conta é obrigatório',
        parentRequired: 'Selecione a conta pai.',
        duplicateCode: 'Código da conta já existe',
        fixErrors: 'Revise os campos obrigatórios antes de continuar.',
        fixErrorsHint:
          'Preencha nome, código e conta pai em todas as linhas destacadas antes de confirmar.',
        postableParentCode:
          'As seguintes contas pai são lançáveis e não podem ser usadas como pai: {{codes}}. Selecione contas sintéticas (não-lançáveis).',
        codesAlreadyExist:
          'Os seguintes códigos já existem no plano de contas: {{codes}}. Altere os códigos antes de continuar.',
        duplicateCodes:
          'Os seguintes códigos estão duplicados na lista: {{codes}}. Cada conta precisa de um código único.',
      },
    },
    createAccountConfirm: {
      title: 'Confirmar criação de conta',
      description: 'A conta contábil será criada e adicionada ao plano de contas, confirma?',
      confirm: 'Confirmar',
      cancel: 'Cancelar',
    },
    noActiveVersion: 'Nenhuma versão ativa do plano de contas (APPLIED) encontrada.',
  },
  systemAccountMapping: {
    title: 'Contas do sistema',
    subtitle: 'Vincule slots do sistema às contas contábeis do plano ativo',
    loading: 'Carregando contas do sistema...',
    error: 'Não foi possível carregar as contas do sistema.',
    toasts: {
      saved: 'Configurações salvas.',
      saveError: 'Não foi possível salvar as configurações.',
      createAccountError: 'Não foi possível criar a conta contábil.',
      aiSuggestSuccess_one: '1 sugestão aplicada',
      aiSuggestSuccess_other: '{{count}} sugestões aplicadas',
      aiSuggestEmpty: 'Todos os slots já estão mapeados ou nenhuma sugestão encontrada',
      aiSuggestError: 'Não foi possível sugerir contas. Tente novamente.',
    },
    footer: {
      noChanges: 'Nenhuma alteração registrada',
      lastUpdated: 'Atualizado em {{date}}',
    },
    buttons: {
      discard: 'Descartar Alterações',
      save: 'Salvar Configurações',
      saving: 'Salvando...',
      aiSuggest: 'Transmutar contas',
      aiSuggesting: 'Transmutando...',
    },
    module: {
      label: 'Módulo',
      description: 'Filtre os slots do sistema por módulo',
      placeholder: 'Selecione um módulo',
    },
    modules: {
      ALL: 'Todos os módulos',
      AP: 'Contas a pagar',
      AR: 'Contas a receber',
      GL: 'Contabilidade',
      HCM: 'Pessoas',
      OP: 'Tesouraria',
      FA: 'Ativos',
    },
    mappings: {
      card: {
        title: 'Mapeamento sistema → contas contábeis',
        description:
          'Vincule cada slot do sistema a uma conta lançável do plano de contas ativo. Você pode criar contas diretamente aqui.',
      },
      missingRequired: '{{count}} obrigatório(s) pendente(s)',
      allRequiredMapped: 'Obrigatórios ok',
      noActiveVersion: 'Nenhuma versão ativa do plano de contas (APPLIED) encontrada.',
      createAccount: 'Criar conta',
      accountPlaceholder: 'Buscar conta...',
      clear: 'Limpar',
      slotsCount: '{{count}} slots',
      categoryRequiredMissing: '{{missing}}/{{total}} pendentes',
      categoryRequiredComplete: '{{total}} obrigatórios ok',
      categories: {
        FINANCIAL_REVENUE: {
          name: 'Receitas financeiras',
          description: 'Descontos financeiros e variações positivas',
        },
        FINANCIAL_EXPENSE: {
          name: 'Despesas financeiras',
          description: 'Juros, multas e outros encargos',
        },
        BANK_FEES: {
          name: 'Tarifas bancárias',
          description: 'Tarifas operacionais cobradas pelo banco',
        },
        TAX_EXPENSE_PAYMENT: {
          name: 'Tributos sobre pagamento',
          description: 'Impostos reconhecidos no pagamento (ex.: IOF)',
        },
        SUPPLIER_ADVANCE: {
          name: 'Adiantamentos a fornecedores',
          description: 'Pagamentos antecipados antes da nota fiscal',
        },
        CREDIT_CARD_LIABILITY: {
          name: 'Cartões de crédito',
          description: 'Passivo do cartão corporativo',
        },
        FX_VARIATION: {
          name: 'Variação cambial',
          description: 'Ganhos e perdas por câmbio',
        },
        PAYROLL_LIABILITY: {
          name: 'Folha de pagamento',
          description: 'Obrigações de salários e encargos',
        },
        PAYROLL_ASSET: {
          name: 'Folha de pagamento (ativos)',
          description: 'Adiantamentos a funcionários e outros ativos de folha',
        },
        RECOVERY_REVENUE: {
          name: 'Receitas de reembolso',
          description: 'Reembolsos e recuperações de despesas',
        },
        CLIENT_RECOVERABLE_ADVANCE: {
          name: 'Valores a recuperar de clientes',
          description: 'Ativos de despesas recuperáveis de clientes',
        },
        VENDOR_LIABILITY: {
          name: 'Fornecedores',
          description: 'Conta-raiz do passivo de fornecedores — uma conta-filha por fornecedor',
        },
        CUSTOMER_RECEIVABLE: {
          name: 'Clientes',
          description: 'Conta-raiz do contas a receber — uma conta-filha por cliente',
        },
        BANK_ACCOUNT: {
          name: 'Contas bancárias',
          description: 'Conta-raiz de bancos — uma conta-filha por conta bancária',
        },
        INVESTMENT_SHORT_TERM: {
          name: 'Investimentos de curto prazo',
          description: 'Conta-raiz das aplicações circulantes — uma conta-filha por posição',
        },
        INVESTMENT_LONG_TERM: {
          name: 'Investimentos de longo prazo',
          description: 'Conta-raiz das aplicações não circulantes — uma conta-filha por posição',
        },
        IN_TRANSIT: {
          name: 'Numerários em trânsito',
          description: 'Conta de trânsito das transferências internas entre datas',
        },
        CUSTODIAL_PAYABLE: {
          name: 'Repasses a parceiros',
          description: 'Raiz do passivo custodial — uma conta-filha por parceiro (hotel)',
        },
        UNBILLED_RECEIVABLE: {
          name: 'Serviços prestados a faturar',
          description:
            'Raiz das transações reconhecidas ainda não faturadas — uma conta-filha por parceiro; reclassificada para Clientes na agregadora',
        },
        SERVICE_TAX_PAYABLE: {
          name: 'Imposto sobre serviços',
          description:
            'Imposto sobre a nossa receita de serviços (ISS, IVA), por estágio: não cobrado e a recolher',
        },
        SERVICE_REVENUE: {
          name: 'Receita de serviços',
          description:
            'Receita de comissões e taxas quando o serviço não declara a sua própria conta',
        },
        ACQUIRER_FEE_EXPENSE: {
          name: 'Comissões de adquirência',
          description: 'Taxa de desconto cobrada pelo adquirente em cada lote liquidado',
        },
        RECOVERABLE_TAX: {
          name: 'Imposto recuperável',
          description: 'Imposto acreditável sobre tarifas e comissões (IVA acreditable)',
        },
        CARD_FINANCING_CLEARING: {
          name: 'Pagamentos financiados por cartão',
          description: 'Pagamentos a fornecedores financiados pelo cartão e ainda não aplicados',
        },
        CONTRACT_ASSET: {
          name: 'Ativo de contrato',
          description: 'Conta-raiz da receita reconhecida ainda não faturada (CPC 47)',
        },
        CONTRACT_LIABILITY: {
          name: 'Passivo de contrato',
          description: 'Conta-raiz do faturamento antecipado ainda não reconhecido (CPC 47)',
        },
        EXPENSE_ACCRUAL: {
          name: 'Provisões de despesas',
          description: 'Contrapartida das despesas provisionadas no fechamento mensal',
        },
        RETAINED_EARNINGS: {
          name: 'Lucros ou prejuízos acumulados',
          description: 'Recebe o resultado do exercício no fechamento do ano fiscal',
        },
        INTANGIBLE_IN_PROGRESS: {
          name: 'Intangível em andamento',
          description:
            'Custo capitalizado de projetos de desenvolvimento ainda não colocados em uso (CPC 04)',
        },
        PREPAID_EXPENSE: {
          name: 'Despesas antecipadas',
          description:
            'Parte de uma conta a pagar que quita uma provisão de custo de serviço de mês seguinte, até a provisão ser lançada',
        },
      },
    },
  },
  approvalDefaults: {
    card: {
      title: 'Comportamento Padrão',
      description: 'Como as contas devem ser tratadas por padrão',
    },
    requireApproval: {
      title: 'Exigir aprovação por padrão',
      recommended: 'Recomendado',
      description:
        'Todas as contas precisam de aprovação, exceto quando um fluxo de auto-aprovação for aplicado. Desative para permitir que contas sejam processadas sem aprovação.',
    },
    autoSubmit: {
      title: 'Enviar contas criadas automaticamente para o fluxo de aprovação',
      recommended: 'Recomendado',
      description:
        'Contas com classificação determinística (regra, reuso, histórico ou IA com precedente aprovado) vão direto ao fluxo de aprovação, sem submissão manual. Quando não houver workflow ou cadeia padrão aplicável, a conta fica em Submetida para revisão manual. Classificações só de IA, sem precedente, também ficam em Submetida.',
    },
    creditCard: {
      card: {
        title: 'Cartões de crédito',
        description: 'Regras aplicadas a transações de cartão de crédito.',
      },
      requireAttachment: {
        title: 'Para transações no cartão de crédito, exigir comprovante acima de:',
        description:
          'Transações sem comprovante acima deste valor serão sinalizadas na conciliação fast-track e não poderão ser postadas no razão.',
        ariaLabel: 'Para transações no cartão de crédito, exigir comprovante acima de valor',
        placeholder: '500',
      },
    },
    clientReimbursable: {
      card: {
        title: 'Despesas reembolsáveis por cliente',
        description:
          'Controle despesas reembolsáveis de maneira automatizada, contábil e financeiramente',
      },
      toggle: {
        title: 'Habilitar despesas reembolsáveis por cliente',
        description:
          'Quando ativo, a conta pode ser marcada como reembolsável por um cliente e será tratada como valor a recuperar, não como despesa final.',
        notEditableFallback: 'Esta flag é controlada pelo WorkOS e não está editável.',
      },
    },
    defaultBillEntity: {
      card: {
        title: 'Entidade padrão para contas',
        description:
          'Usada no início do processamento de contas quando nenhuma entidade do tenant for identificada nos documentos, no e-mail ou nas instruções. Identificadores aceitos: CNPJ, RFC (México) e EIN (EUA).',
      },
      selector: {
        label: 'Entidade padrão',
        placeholder: 'Nenhuma (usar entidade do canal)',
        clearLabel: 'Nenhuma',
      },
      loading: 'Carregando entidade padrão...',
      loadError: 'Não foi possível carregar a entidade padrão das contas.',
      saveError: 'Não foi possível salvar a entidade padrão das contas.',
    },
  },
  cardFastTrack: {
    page: {
      title: 'Classificação rápida de cartão',
      subtitle: 'Classifique e poste transações de cartão com agilidade',
    },
    filters: {
      entityPlaceholder: 'Selecione a entidade',
      allPeriods: 'Todos os períodos',
      attachmentThreshold: 'Comprovante exigido acima de {{amount}}',
      searchPlaceholder: 'Buscar por transação',
      amountMinPlaceholder: 'Valor mín.',
      amountMaxPlaceholder: 'Valor máx.',
      amountInputPlaceholder: 'R$ 0,00',
      amountFilterAria: 'Filtrar por valor',
      datePlaceholder: 'Filtrar por data',
      transactionPlaceholder: 'Filtrar transação',
      vendorPlaceholder: 'Filtrar fornecedor',
      glAccountPlaceholder: 'Filtrar conta contábil',
      managerialAccountPlaceholder: 'Filtrar conta gerencial',
      costCenterPlaceholder: 'Filtrar centro de custo',
      departmentPlaceholder: 'Filtrar departamento',
      apply: 'Aplicar',
      clear: 'Limpar',
      active: {
        title: 'Filtros ativos',
        transaction: 'Transação: {{value}}',
        date: 'Data: {{from}} – {{to}}',
        cards: '{{count}} cartão(ões)',
        amount: 'Valor: {{min}} – {{max}}',
        vendors: '{{count}} fornecedor(es)',
        glAccounts: '{{count}} conta(s) contábil(eis)',
        managerialAccounts: '{{count}} conta(s) gerencial(is)',
        costCenters: '{{count}} centro(s) de custo',
        departments: '{{count}} departamento(s)',
        clearAll: 'Limpar todos',
      },
      cards: {
        allCards: 'Todos os cartões',
        oneCard: '1 cartão',
        manyCards: '{{count}} cartões',
      },
    },
    tabs: {
      ready: 'Prontas',
      incomplete: 'Incompletas',
      refunds: 'Estornos',
      pendingApproval: 'Aguardando aprovação',
      ignored: 'Ignoradas',
      all: 'Todos',
    },
    empty: {
      selectEntity: 'Selecione uma entidade para visualizar as transações',
      noEntitiesTitle: 'Nenhuma entidade disponível',
      noEntitiesDescription:
        'Cadastre uma entidade ou corrija o carregamento das entidades para acessar as transações.',
      noTransactions: 'Nenhuma transação encontrada',
      adjustFilters: 'Ajuste os filtros para ampliar os resultados',
    },
    table: {
      attachmentAdded: 'Comprovante adicionado',
      attachmentRequired: 'Comprovante obrigatório acima de {{amount}}',
      attachmentRequiredHelp: 'Anexe um comprovante para liberar a postagem no razão.',
      setVendor: 'Definir fornecedor',
      automaticClaraVendor: 'Clara',
      automaticContaSimplesVendor: 'Conta Simples',
      automatic: 'Automático',
      automaticClaraVendorHelp:
        'Tarifa IOF da Clara. O fornecedor e o lançamento são definidos automaticamente ao postar.',
      automaticContaSimplesVendorHelp:
        'Tarifa IOF da Conta Simples. O fornecedor e o lançamento são definidos automaticamente ao postar.',
      automaticClaraMxVendorHelp:
        'Encargo do cartão Clara México (comissão, juros, multa por atraso ou IVA). O fornecedor e o lançamento são definidos automaticamente ao postar.',
      automaticMappedAccountHelp: 'Conta mapeada em Mapeamentos Contábeis',
      acceptSuggestion: 'Aceitar sugestão',
      setGlAccount: 'Definir conta contábil',
      setManagerialAccount: 'Definir conta gerencial',
      setCostCenter: 'Definir centro de custo',
      setDepartment: 'Definir departamento',
      approve: 'Aprovar',
      reject: 'Rejeitar',
      selectAll: 'Selecionar todas as transações',
      selectTransaction: 'Selecionar transação',
      refundBadge: 'Estorno',
      refundHelp: 'Estorno de cartão. Não é lançado como despesa; trate na aba Estornos.',
      date: 'Data',
      transaction: 'Transação',
      amount: 'Valor',
      vendor: 'Fornecedor',
      glAccount: 'Conta contábil',
      managerialAccount: 'Conta gerencial',
      costCenter: 'Centro de custo',
      department: 'Departamento',
      attachment: 'Comprovante',
      filterColumn: 'Filtrar coluna',
      resizeColumn: 'Redimensionar coluna',
    },
    toast: {
      billApproved: 'Fatura aprovada com sucesso',
      billApproveError: 'Não foi possível aprovar a fatura',
      billRejected: 'Fatura rejeitada com sucesso',
      billRejectError: 'Não foi possível rejeitar a fatura',
      classificationSaved: 'Classificação salva com sucesso',
      classificationSaveError: 'Erro ao salvar classificação',
      vendorSetError: 'Erro ao atribuir fornecedor',
      vendorClearError: 'Erro ao limpar fornecedor',
    },
    footer: {
      clear: 'Limpar seleção',
      selectedCount_one: '{{count}} selecionada',
      selectedCount_other: '{{count}} selecionadas',
    },
    pagination: {
      range: '{{start}}-{{end}} de {{total}}',
      perPage: 'por página:',
      pageOf: 'Página {{page}} de {{totalPages}}',
    },
    common: {
      cancel: 'Cancelar',
      back: 'Voltar',
    },
    bulk: {
      button: 'Ações em lote',
      selectedBadge_one: '{{count}} selecionado',
      selectedBadge_other: '{{count}} selecionados',
      menuTitle: 'Ações em lote',
      failureReasons: {
        cancelled: 'Transações canceladas não podem ser conciliadas',
        refundNotSupported:
          'Estornos de cartão não são lançados como despesa; trate na aba Estornos',
      },
      menu: {
        classifyTitle: 'Classificar',
        classifyDescription: 'Definir conta contábil, centro de custo e departamento',
        vendorTitle: 'Atribuir fornecedor',
        vendorDescription: 'Definir o mesmo fornecedor para todas as selecionadas',
        vendorAdvanceTitle: 'Adiantamento a fornecedor',
        vendorAdvanceDescription:
          'Criar contas de adiantamento vinculadas aos lançamentos selecionados',
        postTitle: 'Postar no razão',
        postDescription: 'Criar faturas e postar no razão',
        postBlockedMissingVendor_one: '{{count}} sem fornecedor',
        postBlockedMissingVendor_other: '{{count}} sem fornecedor',
        postBlockedMissingAttachment_one: '{{count}} sem comprovante',
        postBlockedMissingAttachment_other: '{{count}} sem comprovante',
      },
      warnings: {
        missingVendor_one:
          '{{count}} transação sem fornecedor - defina o fornecedor antes de postar',
        missingVendor_other:
          '{{count}} transações sem fornecedor - defina o fornecedor antes de postar',
        missingAttachment_one: '{{count}} transação exige comprovante antes do lançamento',
        missingAttachment_other: '{{count}} transações exigem comprovante antes do lançamento',
      },
      toasts: {
        posted_one: '{{count}} transação lançada no razão',
        posted_other: '{{count}} transações lançadas no razão',
        pendingApproval_one: '{{count}} aguardando aprovação',
        pendingApproval_other: '{{count}} aguardando aprovação',
        failed_one: '{{count}} transação com erro',
        failed_other: '{{count}} transações com erro',
        postError: 'Erro ao postar transações',
        vendorAssigned_one: 'Fornecedor atribuído a {{count}} transação',
        vendorAssigned_other: 'Fornecedor atribuído a {{count}} transações',
        vendorAssignError: 'Erro ao atribuir fornecedor',
        classified_one: '{{count}} transação classificada',
        classified_other: '{{count}} transações classificadas',
        classifyError: 'Erro ao classificar transações',
      },
      postConfirm: {
        title: 'Postar no razão',
        description_one:
          'Postar {{count}} transação no razão? Faturas serão criadas automaticamente.',
        description_other:
          'Postar {{count}} transações no razão? Faturas serão criadas automaticamente.',
        attachmentHint: 'Comprovante exigido acima de {{amount}}.',
        confirmLoading: 'Postando...',
        confirm: 'Confirmar {{count}}',
      },
      vendor: {
        title: 'Atribuir fornecedor',
        fieldLabel: 'Fornecedor',
        placeholder: 'Selecione um fornecedor',
        confirmLoading: 'Atribuindo...',
        confirm: 'Atribuir {{count}}',
      },
      classify: {
        title: 'Classificar transações',
        vendorLabel: 'Fornecedor',
        vendorPlaceholder: 'Selecione um fornecedor',
        glLabel: 'Conta contábil',
        glPlaceholder: 'Selecione uma conta',
        managerialLabel: 'Conta gerencial',
        managerialPlaceholder: 'Selecione uma conta gerencial',
        costCenterLabel: 'Centro de custo',
        costCenterPlaceholder: 'Selecione um centro de custo',
        departmentLabel: 'Departamento',
        departmentPlaceholder: 'Selecione um departamento',
        notesLabel: 'Observações',
        notesPlaceholder: 'Observações opcionais...',
        confirmLoading: 'Classificando...',
        confirm: 'Classificar {{count}}',
      },
    },
    ...cardRefundsPtBr,
    readyToPost: {
      title: 'Contas prontas para postar',
      description_one: '{{count}} conta ficou pronta. Deseja postá-la para o razão agora?',
      description_other: '{{count}} contas ficaram prontas. Deseja postá-las para o razão agora?',
      later: 'Agora não',
      confirm: 'Postar no razão',
      posting: 'Postando...',
    },
  },
};

export const tenantSettingsEn = {
  ...revenueTaxEn,
  businessContext: {
    title: 'Global settings',
    subtitle: 'Define business context to guide accounts payable classifications',
    card: {
      title: 'Business context',
      description:
        'Briefly describe what the company does, its products/services, and expense patterns.',
    },
    field: {
      label: 'Context description',
      placeholder: 'Example: B2B SaaS focused on subscriptions and cloud infrastructure.',
      helper: 'Keep it short. It will be used to guide the AI assistant.',
    },
    footer: {
      noChanges: 'No changes recorded',
      lastUpdated: 'Updated on {{date}}',
    },
    buttons: {
      discard: 'Discard changes',
      save: 'Save settings',
      saving: 'Saving...',
    },
    loading: 'Loading settings...',
    error: 'Unable to load settings.',
    toasts: {
      saved: 'Settings saved.',
      saveError: 'Unable to save settings.',
    },
    charCount: '{{count}} / {{max}} characters',
  },
  approvalGlobal: {
    title: 'Approval settings',
    subtitle: 'Define global rules for the accounts payable approval flow',
    loading: 'Loading settings...',
    footer: {
      noChanges: 'No changes recorded',
      readOnly: 'Read-only. Editing requires manage settings permission.',
    },
    buttons: {
      history: 'History',
      discard: 'Discard changes',
      save: 'Save settings',
      saving: 'Saving...',
    },
    tabs: {
      approvals: 'Approvals',
      requiredFields: 'Required fields',
    },
  },
  emailInboxes: {
    card: {
      title: 'Email inboxes',
      description: 'Manage the email addresses that can receive documents and messages for triage.',
    },
    list: {
      loading: 'Loading email inboxes...',
      error: 'Unable to load email inboxes.',
      empty: 'No email inboxes configured.',
      emptyForEntity: 'No email inboxes configured for {{entity}}.',
      alsoServes: 'Also serves: {{entities}}',
    },
    dialog: {
      createTitle: 'Create email inbox',
      editTitle: 'Edit email inbox',
      createDescription: 'Set up the address that receives documents and the companies it serves.',
      editDescription: 'Update the email name and the companies this inbox serves.',
    },
    fields: {
      entity: 'Default company',
      defaultEntity: 'Default company',
      entityPlaceholder: 'Select the default company',
      defaultEntityPlaceholder: 'Select the default company',
      defaultEntityHelper: 'Used when the company is not identified from the document or email.',
      email: 'Email address',
      localPart: 'Email name',
      localPartPlaceholder: 'Example: ap+acme',
      localPartHelper:
        'Use a default company, group, or tenant term. The company identified in the document or email wins; otherwise the default company is used.',
      allowedSenders: 'Allowed senders',
      allowedSendersHelper:
        'Leave empty to accept any sender. Add full emails (e.g. vendor@supplier.com) or domains (e.g. @acme.com or acme.com). Subdomains require an explicit entry.',
      allowedSendersPlaceholder: 'Type and press Enter',
      allowedSendersCount: '{{count}} / {{max}} entries',
      removeAllowedSender: 'Remove allow-list entry',
      allowedUrlDomains: 'Allowed link domains',
      allowedUrlDomainsHelper:
        'Domains whose email-body links may be downloaded as attachments. For Pipefy, use app.pipefy.com. Leave empty to avoid downloading body links.',
      allowedUrlDomainsPlaceholder: 'Example: app.pipefy.com',
      allowedUrlDomainsCount: '{{count}} / {{max}} domains',
      removeAllowedUrlDomain: 'Remove domain entry',
      autoReplyEnabled: 'Reply to senders automatically',
      autoReplyEnabledHelper:
        'When off, the agent sends no email to the person who sent the message. If something only the sender can give is missing, the email goes to "E-mails that did not become a bill".',
      badgeOpen: 'Accepts all',
      badgeRestricted: 'Restricted',
      sharedEntities: 'Companies served',
      sharedEntitiesHelper:
        'The default company is always included. With only the default, each document goes to the company of its CNPJ, or to the default when it has none. With more than one company, an email that does not name the company waits until someone chooses one.',
      sharedEntitiesDefaultTag: 'Default',
      sharedEntitiesAll: 'All companies',
      sharedEntitiesPlaceholder: 'Select the companies',
    },
    buttons: {
      create: 'Create inbox',
      edit: 'Edit',
      cancel: 'Cancel',
      save: 'Save',
      saving: 'Saving...',
    },
    validation: {
      entityRequired: 'Please select a company.',
      invalidEmail: 'Please provide a valid email address.',
      invalidLocalPart: 'Please provide a valid email name (before @).',
      mustIncludeEntityToken: 'Include at least one of these terms: {{tokens}}.',
      emailNotUnique: 'This email address is already in use.',
      invalidAllowedSender: 'Invalid allow-list entry.',
      allowedSendersMax: 'At most {{max}} allow-list entries.',
      invalidAllowedUrlDomain: 'Invalid allowed link domain.',
      allowedUrlDomainsMax: 'At most {{max}} allowed link domains.',
    },
    toasts: {
      created: 'Email inbox created.',
      updated: 'Email inbox updated.',
      saveError: 'Unable to save the email inbox.',
    },
  },
  labCards: {
    rejectedEmailSenders: {
      title: 'E-mails from senders not allowed',
      description:
        'Some received messages were rejected because the sender address is not on the allowed list.',
      loadingLabel: 'Loading rejected e-mails…',
      rowNoun: { one: 'rejected e-mail', other: 'rejected e-mails' },
      badgeUnread: '{{count}} unread',
      openList: 'View details',
      dialogTitle: 'Rejected inbound emails',
      onlyUnread: 'Unread only',
      markRead: 'Mark as read',
      markReadError: 'Could not mark the e-mails as read. Try again.',
      loadError: 'Unable to load rejection log.',
      empty: 'No rejections recorded.',
      columns: {
        sender: 'Sender',
        target: 'Inbox',
        at: 'When',
        reason: 'Reason',
      },
      reasonNotOnAllowList: 'Sender not on allow-list',
      linkSettings: 'Configure allow-lists in Organization context',
    },
  },
  vendorContextUpload: {
    card: {
      title: 'Vendor historical context',
      badge: '{{count}} vendors',
      description:
        'Upload historical classifications by entity using CNPJ, CPF, or a foreign Tax ID.',
    },
    fields: {
      entityLabel: 'Entity',
      fileLabel: 'CSV file',
      fileHelper: 'Include a Tax ID column and the classification dimensions.',
      selectedFile: 'Selected file: {{fileName}}',
    },
    buttons: {
      upload: 'Upload CSV',
      uploading: 'Uploading...',
    },
    status: {
      label: 'Processing status',
      pending: 'Pending',
      processing: 'Processing',
      completed: 'Completed',
      failed: 'Failed',
      cancelled: 'Cancelled',
    },
    progress: {
      summary: 'Processing {{processed}} of {{total}} vendors',
      noTotals: 'Processing in progress',
    },
    errors: {
      loadStatus: 'Unable to load processing status.',
      jobFailed: 'Processing failed: {{message}}',
      jobFailedFallback: 'Unknown error.',
      vendorFailures: '{{count}} vendor(s) could not be processed.',
    },
    toasts: {
      started: 'Processing started.',
      uploadError: 'Unable to upload the file.',
      missingFile: 'Select a CSV file before uploading.',
      missingEntity: 'Select an entity before uploading.',
    },
    skips: {
      summary: '{{count}} ignored row(s)',
      emptyTaxId: '{{count}} without a Tax ID',
      invalidTaxId: '{{count}} with an invalid Tax ID',
      unsupportedType: '{{count}} with an unsupported type',
      missingCountry: '{{count}} without a country',
      invalidCountry: '{{count}} with an invalid country',
    },
    mappingDialog: {
      title: 'Map CSV columns',
      description: 'Choose the Tax ID, country, and dimensions for the selected entity.',
      loading: 'Analyzing CSV file...',
      headerColumn: 'CSV column',
      mappingColumn: 'Target field',
      previewColumn: 'Sample',
      defaults: {
        taxIdType: 'Default Tax ID type',
        country: 'Default country',
      },
      taxIdTypes: {
        AUTO: 'Detect CPF or CNPJ',
        CNPJ: 'CNPJ',
        CPF: 'CPF',
        INTERNATIONAL: 'International Tax ID',
      },
      fields: {
        taxId: 'Tax ID',
        taxIdType: 'Tax ID type',
        countryCode: 'Country',
        legalName: 'Vendor legal name',
        glAccountName: 'GL account',
        managerialAccountName: 'Managerial account',
        costCenterName: 'Cost center',
        departmentName: 'Department',
        amount: 'Amount',
        date: 'Date',
        origin: 'Origin / Document type',
        skip: 'Skip (extra metadata)',
      },
      errors: {
        noTaxId: 'Select the Tax ID column.',
        internationalCountry: 'Select a foreign country or map a country column.',
        parse: 'Unable to read the CSV file.',
      },
      duplicateColumns: 'The columns {{columns}} were selected more than once.',
      unmappedHint: '{{count}} unmapped column(s) will be stored as extra metadata: {{columns}}',
      buttons: {
        confirm: 'Confirm and upload',
        confirming: 'Uploading...',
        cancel: 'Cancel',
      },
    },
    emptyState: {
      noJob: 'No processing jobs running.',
    },
    history: {
      title: 'Import history',
      selectEntity: 'Select an entity to view its imports.',
      loading: 'Loading imports...',
      error: 'Unable to load import history.',
      empty: 'No imports found.',
      legacy: 'Legacy context',
      processed: '{{processed}} of {{total}} vendors processed',
      pagination: 'Page {{page}} of {{totalPages}}',
      previous: 'Previous page',
      next: 'Next page',
      columns: {
        import: 'Import',
        entity: 'Entity',
        status: 'Status',
        result: 'Result',
      },
    },
  },
  entityPaymentConfig: {
    title: 'Payment Days',
    subtitle: 'Configure the default due date per company',
    loading: 'Loading payment settings...',
    error: 'Unable to load payment settings.',
    toasts: {
      saved: 'Settings saved.',
      saveError: 'Unable to save settings.',
    },
    footer: {
      noChanges: 'No changes recorded',
      unsavedChanges: 'Unsaved changes',
      lastUpdated: 'Updated on {{date}}',
    },
    buttons: {
      discard: 'Discard changes',
      save: 'Save settings',
      saving: 'Saving...',
    },
    config: {
      card: {
        title: 'Default due date',
        description:
          'Defines the default due date when no explicit date is available (e.g. NF without a due date).',
      },
      fields: {
        entity: 'Company',
        entityPlaceholder: 'Select a company',
        mode: 'Scheduling mode',
        modePlaceholder: 'Select mode',
        modeHelp:
          'Weekdays: pick one or more fixed days. Month days: pick one or more days (1–31).',
        days: 'Days',
        noConfig: 'No default configuration',
        noConfigHelp: 'When not configured, the system falls back to issue date + 30 days.',
      },
      enums: {
        mode: {
          WEEKDAYS: 'Days of the week',
          MONTH_DAYS: 'Days of the month',
        },
        weekdays: {
          '0': 'Sun',
          '1': 'Mon',
          '2': 'Tue',
          '3': 'Wed',
          '4': 'Thu',
          '5': 'Fri',
          '6': 'Sat',
        },
      },
    },
  },
  entityReimbursementPaymentConfig: {
    title: 'Reimbursement payments',
    subtitle: 'Configure expected reimbursement payment dates per company',
    loading: 'Loading reimbursement settings...',
    error: 'Unable to load reimbursement settings.',
    toasts: {
      saved: 'Reimbursement settings saved.',
      saveError: 'Unable to save reimbursement settings.',
    },
    footer: {
      noChanges: 'No changes recorded',
      unsavedChanges: 'Unsaved changes',
    },
    buttons: {
      discard: 'Discard changes',
      save: 'Save settings',
      saving: 'Saving...',
    },
    config: {
      card: {
        title: 'Expected reimbursement payment date',
        description: 'Defines the global company rule used when the policy uses global settings.',
      },
      fields: {
        entity: 'Company',
        entityPlaceholder: 'Select a company',
        mode: 'Scheduling mode',
        modePlaceholder: 'Select mode',
        modeHelp: 'Choose fixed days or a deadline relative to submission/approval.',
        days: 'Days',
        offsetDays: 'D+n days',
        anchor: 'Anchor',
        noConfig: 'No global configuration',
        noConfigHelp: 'When not configured, the system falls back to D+7 after submission.',
      },
      enums: {
        mode: {
          WEEKDAYS: 'Days of the week',
          MONTH_DAYS: 'Days of the month',
          OFFSET_DAYS: 'D+n days',
        },
        anchor: {
          SUBMISSION: 'After submission',
          APPROVAL: 'After approval',
        },
        weekdays: {
          '0': 'Sun',
          '1': 'Mon',
          '2': 'Tue',
          '3': 'Wed',
          '4': 'Thu',
          '5': 'Fri',
          '6': 'Sat',
        },
      },
    },
  },
  // ALC-1504 — see the pt-BR block.
  statutoryTreatment: {
    title: 'Tax slip treatment',
    subtitle: 'Per entity, how each tax is classified and posted on approval',
    entity: 'Entity',
    entityPlaceholder: 'Select the entity',
    loading: 'Loading taxes...',
    unavailable: {
      title: 'Setting unavailable for this accounting standard',
      description:
        'CPC-based tax slip treatment is available only to entities with at least one book using the BR_CPC standard. Standards for this entity: {{frameworks}}.',
      noBooks: 'no accounting books linked',
    },
    card: {
      title: 'Treatment per tax',
      description: 'How to handle tax provisioning in Accounts Payable.',
    },
    columns: {
      slot: 'Tax',
      treatment: 'Treatment',
      source: 'Source',
      actions: '',
    },
    modes: {
      BYPASS: 'Use source liability',
      AUTO_PROVISION: 'Automatic provisioning',
      CLASSIFY: 'Classify',
    },
    modeDescriptions: {
      BYPASS:
        'Requires a liability recognized by the legal event; the tax slip only reclassifies valid origins and blocks when the producer does not exist.',
      AUTO_PROVISION:
        'Transfers the principal from Assessed to Tax slips payable on approval, even when Assessed becomes negative.',
      CLASSIFY: 'Requires accounting classification before the tax slip can be approved.',
    },
    categories: {
      WITHHOLDING_AP: 'Supplier withholdings',
      OWN_AR: 'Own taxes',
      PAYROLL: 'Payroll',
      DEDUCTION: 'Revenue deductions',
      RECOVERABLE: 'Recoverable taxes',
      TAX_EXPENSE: 'Tax expenses',
    },
    source: {
      configured: 'Configured',
      default: 'Default ({{treatment}})',
    },
    actions: {
      reset: 'Reset to default',
    },
    noAutoProvisionShort: 'no offset account',
    noAutoProvisionReason:
      'This tax has no offset account defined for provisioning when the tax slip is approved.',
    toast: {
      saved: 'Treatment updated',
      reset: 'Treatment reset to default',
      error: 'Could not save: {{message}}',
    },
  },
  fiscalRegimeAliquotas: {
    title: 'Regime & Rates',
    subtitle: 'Configure fiscal parameters per company',
    loading: 'Loading fiscal settings...',
    error: 'Unable to load fiscal settings.',
    toasts: {
      saved: 'Settings saved.',
      saveError: 'Unable to save settings.',
    },
    footer: {
      noChanges: 'No changes recorded',
      lastUpdated: 'Updated on {{date}}',
    },
    buttons: {
      discard: 'Discard changes',
      save: 'Save settings',
      saving: 'Saving...',
    },
    successor: {
      action: 'Start new fiscal period',
      title: 'New fiscal period',
      description:
        'Record the taxpayer change with the date and evidence supporting the new regime.',
      loading: 'Loading fiscal history...',
      loadError: 'Unable to load fiscal history. Try again.',
      activePeriodRequired:
        'The taxpayer must have exactly one active fiscal period before starting its successor.',
      currentPeriod: 'Active fiscal period since {{from}}.',
      validFrom: 'New period start',
      validFromPlaceholder: 'dd/mm/yyyy',
      validFromHelp: 'Enter the first day of the month when the change takes effect.',
      validFromError: 'Enter the first day of a month after the current fiscal period began.',
      companyTaxRegime: 'New tax regime',
      pisCofinsRegime: 'New PIS/COFINS regime',
      dueBasis: 'New recognition basis',
      dueBasisAccrual: 'Accrual',
      dueBasisCash: 'Cash',
      exceptionReason: 'Legal reason for a midyear change',
      exceptionPlaceholder: 'Select the reason',
      exception: {
        START_OF_ACTIVITY: 'Start of activity',
        MANDATORY_LUCRO_REAL: 'Mandatory Lucro Real qualification',
        OTHER_WITH_EVIDENCE: 'Other reason with evidence',
      },
      evidenceCode: 'Evidence code',
      evidenceDescription: 'Evidence description',
      warningTitle: 'Review the warnings before confirming',
      confirmation:
        'I confirm the effective period, regimes, and evidence entered and acknowledge the fiscal warnings for this change.',
      saveOrDiscardFirst: 'Save or discard the form changes before starting a new fiscal period.',
      save: 'Start period',
      confirmWarnings: 'Confirm and start period',
      cancel: 'Cancel',
      error: 'Unable to start the new fiscal period.',
    },
    config: {
      card: {
        title: 'Company configuration',
        description:
          'Define tax regime and parameters used in withholding calculations per company.',
      },
      fields: {
        entity: 'Company',
        entityPlaceholder: 'Select a company',
        companyTaxRegime: 'Tax regime',
        companyTaxRegimePlaceholder: 'Select regime',
        pisCofinsRegime: 'PIS/COFINS regime',
        pisCofinsRegimePlaceholder: 'Select regime',
        pisCofinsRegimeDisabledHelp:
          'PIS/COFINS not applicable for Simples Nacional (included in DAS).',
        pisCofinsRegimeLockedHelp: 'Regime fixed to Cumulative for Lucro Presumido.',
        defaultPisRate: 'Default PIS rate',
        defaultCofinsRate: 'Default COFINS rate',
        irrfMinimumAmount: 'IRRF withholding (minimum amount)',
        irrfMinimumAmountHelp:
          'Minimum IRRF amount for withholding, evaluated per payment. If the calculated tax is equal to or below this amount, withholding is waived (Art. 67 of Law 9,430/96). There is no accumulation across invoices.',
        defaultIssMunicipality: 'Default NFS-e municipality',
        defaultIssMunicipalityHelp:
          'IBGE municipality used by default for entity NFS-e issuance. Billing services can override this value.',
        defaultIssMunicipalityPlaceholder: 'Type to search Focus NFe',
        autoCalculateWithholdings: 'Auto-calculate withholdings',
        autoCalculateWithholdingsHelp: 'Suggest values based on fiscal rules by service type.',
        requireWithholdingConfirmation: 'Require withholding confirmation',
        requireWithholdingConfirmationHelp: 'Forces a manual check before finalizing.',
        takeCreditFromSimples: 'Allow Simples credits',
        takeCreditFromSimplesHelp: 'Enables presumed credits when applicable.',
        simplesDefaultCreditRate: 'Simples default credit rate',
        simplesDefaultCreditRatePlaceholder: 'Example: 0.02',
      },
      // Labels and helper lines of the Entities page tab (the create dialog keeps `fields`).
      sections: {
        optional: 'optional',
        pisRate: 'PIS (default)',
        cofinsRate: 'COFINS (default)',
        irrfMinimum: 'IRRF withholding (minimum amount)',
        municipalityHelp: 'Each billing service can override this municipality.',
        autoCalculateWithholdingsHelp:
          'Suggests IRRF, CSRF, INSS and ISS on each payable based on the vendor and the service.',
      },
      groups: {
        regime: {
          title: 'Regime',
          subtitle: 'How the company is taxed and how PIS and COFINS are assessed.',
        },
        rates: {
          title: 'Rates',
          subtitle: 'Default PIS and COFINS rates and the minimum amount to withhold IRRF.',
        },
        nfse: {
          title: 'NFS-e',
          subtitle: 'Municipality used by default when issuing service invoices.',
        },
        withholdings: {
          title: 'Withholdings and credits',
          subtitle: 'How withholdings are suggested and confirmed, and the Simples credit.',
        },
      },
      enums: {
        companyTaxRegime: {
          SIMPLES_NACIONAL: 'Simples Nacional',
          LUCRO_PRESUMIDO: 'Presumed profit',
          LUCRO_REAL: 'Actual profit',
        },
        pisCofinsRegime: {
          CUMULATIVE: 'Cumulative',
          NON_CUMULATIVE: 'Non-cumulative',
        },
      },
    },
  },
  fiscalAccountMapping: {
    title: 'Account Mapping',
    subtitle: 'Map fiscal slots to accounts in the active chart',
    loading: 'Loading fiscal settings...',
    error: 'Unable to load fiscal settings.',
    toasts: {
      saved: 'Settings saved.',
      saveError: 'Unable to save settings.',
      rootScopeGlobal:
        'Root accounts are global settings. Clear the entity/book scope before saving them.',
      createAccountError: 'Unable to create the GL account.',
      aiSuggestSuccess_one: '1 suggestion applied',
      aiSuggestSuccess_other: '{{count}} suggestions applied',
      aiSuggestEmpty: 'All slots are already mapped or no suggestions found',
      aiSuggestError: 'Unable to suggest accounts. Please try again.',
    },
    footer: {
      noChanges: 'No changes recorded',
      lastUpdated: 'Updated on {{date}}',
    },
    buttons: {
      discard: 'Discard changes',
      save: 'Save settings',
      saving: 'Saving...',
      aiSuggest: 'Transmute accounts',
      aiSuggesting: 'Transmuting...',
    },
    requiredForAll: 'Required for all regimes',
    requiredForRegimes: 'Required for: {{regimes}}',
    mappings: {
      card: {
        title: 'Tax → GL account mappings',
        description:
          'Link each tax slot to a postable account in the active chart of accounts. You can create accounts directly here.',
      },
      required: 'Required',
      missingRequired: '{{count}} required missing',
      allRequiredMapped: 'Required ok',
      noActiveVersion: 'No active chart of accounts version (APPLIED) found.',
      createAccount: 'Create account',
      accountPlaceholder: 'Search account...',
      clear: 'Clear',
      jurisdictionCategory: '{{jurisdiction}} • {{category}}',
      categories: {
        WITHHOLDING_AP: {
          name: 'Withholdings payable',
          description: 'Taxes withheld from suppliers (PIS, COFINS, CSLL, INSS, ISS)',
        },
        OWN_AR: {
          name: 'Own taxes due',
          description: "Company's own taxes (PIS, COFINS, IPI, IRPJ, CSLL, ISS)",
        },
        DEDUCTION: {
          name: 'Revenue deductions',
          description: 'Income reductions (PIS, COFINS, ISS on revenue)',
        },
        TAX_EXPENSE: {
          name: 'Tax expenses',
          description: 'Tax fines and interest, and income-tax provisions (IRPJ, CSLL)',
        },
        RECOVERABLE: {
          name: 'Recoverable credits',
          description: 'Recoverable credits (PIS, COFINS, IRRF, suffered withholdings)',
        },
        PAYROLL: {
          name: 'Payroll taxes',
          description: 'Payroll taxes (INSS, FGTS, IRRF on earnings)',
        },
      },
    },
  },
  accountMapping: {
    selectionWarning: {
      type: 'Account {{code}} is {{actualType}} ({{actualNature}}). This field requires {{expectedType}} ({{expectedNature}}). Select a compatible account or review its chart configuration.',
      managed:
        'Account {{code}} is managed by tax {{owner}} and cannot be selected directly here. Review sharing in the tax liability configuration flow.',
      inactive: 'Account {{code}} is inactive. Activate it in the chart or select another account.',
      nonPostable: 'Account {{code}} cannot receive direct postings. Select a postable account.',
      unavailable:
        'Account {{code}} is not among the permitted options for this field. Review the mapping or select another account.',
    },
    title: 'Mappings',
    subtitle: 'Configure root accounts, system slots, and fiscal slots in one place',
    loading: 'Loading mapping...',
    error: 'Unable to load mapping.',
    scope: {
      title: 'Chart of accounts scope',
      description:
        'The accounts, suggestions, and mappings below use the active version for this entity/book.',
      entityLabel: 'Entity',
      bookLabel: 'Book',
      activeVersion: 'Active version: {{version}}',
      selectScope: 'Select an entity to load mappings.',
      resolveError: 'Could not resolve the active version: {{message}}',
    },
    cashLayer: {
      title: 'Root account usage',
      description:
        "Choose whether this entity's banks, investments and cards use the root account in the table or a posting account on the form.",
      switchLabel: 'Require a posting account on the form',
      directDescription:
        'On the form, the only choice is an existing posting account. The root account is chosen only in this mapping. Without it, the entry is not posted until you select one.',
      rootDescription:
        'Map the root account on the row below. On the first posting, the system creates a posting account under that root.',
      slots: {
        OP_BANK_ACCOUNT: 'Bank accounts',
        OP_INVESTMENT_SHORT_TERM: 'Investment accounts',
        OP_CREDIT_CARD: 'Credit cards',
      },
      rootHints: {
        OP_BANK_ACCOUNT:
          "This entity's postings don't use this root account. Link the posting account on each bank account, in the Cash menu, under Bank accounts.",
        OP_INVESTMENT_SHORT_TERM:
          "This entity's postings don't use this root account. Link the posting account on each investment account, in the Cash menu, under Bank accounts.",
        OP_CREDIT_CARD:
          "This entity's postings don't use this root account. Link the posting account on each card, in the Cash menu, under Credit cards.",
      },
      saved: 'Root account usage saved.',
      loading: 'Loading root account usage',
      loadError: 'Unable to load root account usage.',
      errors: {
        linksOutsideRoot:
          "Can't use the root account again: some records are linked to accounts outside it. Link them to accounts under the root and try again.",
        generic: 'Unable to save the setting. Try again.',
      },
    },
    tabs: {
      setupTotal: '{{setup}}/{{total}}',
      ROOT: 'Root accounts',
      AP: 'Accounts payable',
      AR: 'Accounts receivable',
      GL: 'General ledger',
      HCM: 'People',
      OP: 'Treasury',
      FISCAL: 'Fiscal',
      FA: 'Fixed assets',
    },
    rfbReference: {
      code: 'RFB · {{code}}',
      unverified: 'RFB · No verified reference',
      openSource: 'RFB reference {{code}} — open official source in a new tab',
      scope:
        'ECF, layout {{layout}}: calendar year 2025 and special situations in 2026. General companies under lucro real or presumido.',
      rows: 'Sheets and rows: {{rows}}',
      status: {
        VERIFIED_FAMILY:
          'Suggested reference family for this tax. It does not replace the company’s GL account.',
        CONDITIONAL_FAMILY:
          'Indicative reference: confirm the transaction, tax regime and credit entitlement before applying.',
        LEGACY_CONTEXT_REQUIRED:
          'Legacy mapping: confirm the legal withholding context before using this reference.',
        POLICY_REQUIRED:
          'The catalog has no verified specific reference for this tax. Accounting review is required.',
      },
    },
    table: {
      settingName: 'Setting',
      slotName: 'Slot',
      category: 'Category',
      accountType: 'Account type',
      description: 'Description',
      glAccount: 'GL account',
      actions: 'Actions',
      accountPlaceholder: 'Search account...',
      clear: 'Clear',
      createAccount: 'Create account',
      invalidTaxAccount: '{{code}}: account type or balance is incompatible with this tax.',
      invalidIncomeTaxAccount: '{{code}}: select or create a non-operating expense account.',
      aiCreateSuggestion: 'AI suggestion',
      // Distinguishes a MAP suggestion (an account already picked by the AI, pending the user's
      // confirmation) from a saved mapping — the Wand2 icon alone reads the same either way
      // (Bug 032).
      aiMapSuggestion: 'AI suggestion — not saved yet',
      managedByTaxRail:
        'Managed by the {{slotCode}} fiscal structure. Balances remain separate by tax.',
      provisionVacationMappedToPayable:
        'A vacation payable account is mapped; payroll expects the provision account.',
      provisionThirteenthMappedToPayable:
        'A 13th-salary payable account is mapped; payroll expects the provision account.',
    },
    toasts: {
      saved: 'Settings saved.',
      railsConfigured: 'Fiscal rail(s) configured.',
      saveError: 'Unable to save settings.',
      railAccountClaimed:
        'The structure of account {{accountCode}} is incompatible with this mapping. Review the accounting configuration.',
      createAccountError: 'Unable to create the GL account.',
      aiSuggestSuccess_one: '1 suggestion applied',
      aiSuggestSuccess_other: '{{count}} suggestions applied',
      aiSuggestEmpty: 'All slots are already mapped or no suggestions found',
      aiSuggestError: 'Unable to suggest accounts. Please try again.',
    },
    fpaRemap: {
      title: 'This mapping changes the FP&A income statement',
      description:
        'The tax slots you changed are named by Contábil FP&A rollups. Confirming applies the new mapping to DRE membership — including live history already evaluated from these slots.',
      canApply:
        'You have FP&A permission (fpa:manage). Confirm only if you also want to update those DRE rollups.',
      needsPermission:
        'You do not have FP&A permission (fpa:manage). Ask someone who does to apply this mapping to the rollups, or wait until they update FP&A before saving the fiscal mapping.',
      cancel: 'Cancel',
      confirm: 'Apply to FP&A as well',
    },
    railRepair: {
      notice:
        'This tax is not set up. Account {{accountCode}} is a group account and does not take postings, so approving bills with this tax fails.',
      action: 'Set up tax structure',
      title: 'Set up tax structure',
      description:
        '{{taxName}} uses the group account {{accountCode}} {{accountName}}. Pick which child account takes each stage of the tax.',
      apuradoLabel: 'Apurado',
      apuradoHelp: 'Takes the withheld tax when a bill is approved.',
      guidesLabel: 'Em guias a pagar',
      guidesHelp: 'Takes the tax when it goes on an approved guide (DARF), until it is paid.',
      placeholder: 'Pick a child account',
      samePick: 'Pick an account different from the Apurado stage.',
      sharedTaxes: 'This structure is also used by: {{taxes}}.',
      noJournal: 'No journal entry is created. Current balances stay where they are.',
      cancel: 'Cancel',
      confirm: 'Set up structure',
      success: 'Tax structure set up.',
      successDetail:
        'Bills with {{taxes}} can now be approved. Earlier entries stay on account {{accountCode}}.',
      close: 'Close',
      billToastTitle: 'The tax {{taxName}} is not set up.',
      billToastDescription: 'Set up the tax structure to approve this bill.',
      billToastDescriptionNoAccess:
        'Ask someone who manages settings to set up this tax structure.',
      billToastAction: 'Set up',
    },
    railErrors: {
      TAX_RAIL_ALIAS_OUTSIDE_RAIL:
        'This tax already has a payroll-linked account. Select that account or its structure’s parent. Using another account requires an accounting migration of the balances.',
      TAX_LIABILITY_RAIL_ACCOUNT_ALREADY_CLAIMED:
        'The structure of account {{accountCode}} is incompatible with {{taxName}}. Review the accounting configuration.',
      TAX_LIABILITY_RAIL_MAPPING_CONFLICT:
        'This tax already uses the managed account "{{accountName}}". The "Apurado" and "Em Guias a Pagar" accounts are posted to automatically by the system and cannot be selected here — pick the parent account instead.',
      TAX_LIABILITY_RAIL_APPLIED_REMAP_FORBIDDEN:
        'This tax is already mapped on an applied chart of accounts and its current account holds historical entries. Select the account that is already mapped to convert it into a managed account; pointing somewhere else would abandon the existing balances.',
      TAX_LIABILITY_RAIL_LIVE_REMAP_FORBIDDEN:
        'This tax already has postings in the active chart of accounts. Keep the mapped account to convert it into a managed account; it cannot be replaced with another account.',
      TAX_LIABILITY_RAIL_SUPERSEDED_REMAP_FORBIDDEN:
        'This chart of accounts was replaced and retains fiscal history. Map the tax on the active chart; the historical link cannot be changed.',
      selectedAccount: 'selected account',
      selectedTax: 'Tax mapping',
      unknownAccountType: 'an incompatible type',
      unknownBalance: 'unknown',
      accountTypes: {
        ASSET: 'asset',
        LIABILITY: 'liability',
        EQUITY: 'equity',
        REVENUE: 'revenue',
        COGS: 'cost of goods sold',
        EXPENSE: 'expense',
        OTHER_EXPENSE: 'other expense',
        OTHER_INCOME: 'other income',
      },
      balances: { DEBIT: 'debit', CREDIT: 'credit' },
      TAX_LIABILITY_RAIL_PARENT_INVALID_ACCOUNT_TYPE:
        '{{taxName}}: account "{{accountName}}" is classified as {{accountType}} with a {{naturalBalance}} balance. This mapping requires a credit-balance liability. Choose another account or review its chart configuration.',
      TAX_LIABILITY_RAIL_PARENT_INVALID_NATURAL_BALANCE:
        '{{taxName}}: account "{{accountName}}" has a debit balance; this mapping requires a credit balance. Choose another account or review its chart configuration.',
      TAX_LIABILITY_RAIL_PARENT_INVALID_INACTIVE:
        '{{taxName}}: account "{{accountName}}" is inactive. Activate it in the chart or choose another account.',
      TAX_LIABILITY_RAIL_PARENT_INVALID_NOT_POSTABLE:
        '{{taxName}}: account "{{accountName}}" cannot receive direct postings. Select a postable account.',
      TAX_LIABILITY_RAIL_PARENT_INVALID_WRONG_VERSION:
        '{{taxName}}: account "{{accountName}}" belongs to a different chart of accounts. Select an account from this chart.',
      TAX_LIABILITY_RAIL_PARENT_INVALID_NOT_FOUND:
        '{{taxName}}: the selected account was not found. Refresh the list and choose another account.',
      TAX_LIABILITY_RAIL_PARENT_INVALID_SLOT_NOT_ELIGIBLE:
        '{{taxName}} does not use stages. Save it through regular tax mapping.',
      TAX_LIABILITY_RAIL_PARENT_INVALID:
        'Could not map {{taxName}} to "{{accountName}}". Select an active, postable credit-liability account in this chart.',
      TAX_LIABILITY_RAIL_SLOT_NOT_ELIGIBLE:
        'This tax is not collected through a payment slip, so it does not use staged managed accounts.',
      TAX_LIABILITY_RAIL_DUPLICATE_SLOT:
        'The same tax was submitted more than once. Refresh the page and try again.',
      TAX_LIABILITY_RAIL_CONFIGURATION_INVALID:
        'The fiscal rails could not be configured. Review the tax mappings and try again.',
      TAX_LIABILITY_RAIL_MIGRATION_FLOW_REQUIRED:
        'Taxes collected through a payment slip are changed through the migration flow, which confirms the balance, validates the open period, and posts the journal entry in one operation. To switch accounts, select the new account on this tax and save. Clearing the mapping is not supported yet — talk to the accounting team.',
      TAX_LIABILITY_RAIL_MIGRATION_CONFIRMATION_REQUIRED:
        'Tax balances need confirmation before migration. Review the selected dates and assessment periods.',
      TAX_LIABILITY_RAIL_MIGRATION_EFFECTIVE_DATE_REQUIRED:
        'Enter an effective date for each tax balance that will be migrated.',
      TAX_LIABILITY_RAIL_MIGRATION_ASSESSMENT_PERIOD_REQUIRED:
        'Enter a valid assessment period for each tax balance that will be migrated.',
      TAX_LIABILITY_RAIL_MIGRATION_OPEN_PERIOD_REQUIRED:
        'The effective date must fall in an open accounting period. Choose a valid date and try again.',
      TAX_LIABILITY_RAIL_MIGRATION_DEBIT_BALANCE:
        'A debit balance was found in a tax liability account. It needs accounting review before migration.',
      TAX_LIABILITY_RAIL_DEBIT_BALANCE:
        'A debit balance was found in a tax liability account. It needs accounting review before migration.',
      TAX_LIABILITY_RAIL_MIGRATION_EFFECTIVE_DATE_BALANCE_MISMATCH:
        'Could not migrate {{taxName}}: on {{effectiveDate}}, the balance is {{effectiveDateAmount}}, while the Legado balance to migrate is {{currentBalance}}. Use effective date {{suggestedEffectiveDate}} and assessment period {{suggestedAssessmentPeriod}}.',
      balanceMismatchNoSuggestedDate: 'a date in the open period containing the Legado balance',
      TAX_RAIL_SLOT_MAPPING_INVALID:
        'This tax mapping does not point to a valid liability account. Choose an active, postable credit account.',
      TAX_RAIL_FRAMEWORK_MISMATCH: 'Fiscal rails are available only for BR CPC accounting books.',
      TAX_RAIL_BR_CPC_ONLY: 'Fiscal rails are available only for BR CPC accounting books.',
      TAX_RAIL_REQUIRES_BR_CPC_BOOK: 'Fiscal rails are available only for BR CPC accounting books.',
      TAX_RAIL_BOOK_SCOPE_MISMATCH:
        'The selected account and book must belong to the same scope. Review the mapping and try again.',
      TAX_RAIL_MIXED_FRAMEWORK_VERSION:
        'This chart of accounts version is shared with a book from another framework and cannot use BR CPC fiscal rails.',
      TAX_RAIL_SLOT_NOT_ENABLED:
        'This tax is not enabled for a fiscal rail in this chart of accounts.',
      TAX_RAIL_CONFIGURATION_INVALID:
        'The fiscal rail could not be configured. Review the tax mapping and try again.',
      TAX_LIABILITY_RAIL_MAPPING_CONFLICT_UNKNOWN:
        'This tax already uses a managed account. The "Apurado" and "Em Guias a Pagar" accounts are posted to automatically by the system and cannot be selected here — pick the parent account instead.',
      TAX_LIABILITY_RAIL_MAPPING_INVALID:
        'The managed account for this tax could not be configured. Review the selected account and try again.',
      TAX_LIABILITY_RAIL_SETUP_REQUIRED:
        'The tax {{taxName}} is not set up. Account {{accountCode}} is a group account and does not take postings. Set up the tax structure.',
      TAX_LIABILITY_RAIL_REPAIR_ACCOUNTS_INVALID:
        'The accounts you picked are not the two child accounts of the group account. Pick a different child account for each stage.',
      TAX_LIABILITY_RAIL_REPAIR_SCOPE_REQUIRED:
        'You do not have access to all the accounting data this setup affects. Ask someone with access to every company on this chart of accounts.',
      TAX_LIABILITY_RAIL_REPAIR_STALE:
        'The taxes that use this group account changed. Close this window and open the setup again.',
      TAX_RAIL_GUIDES_BALANCE_NOT_ZERO:
        'The account picked for Em guias a pagar already has a balance. This stage must start with no balance. Pick another child account.',
      TAX_RAIL_STAGED_ACCOUNTS_UNUSABLE:
        'The tax structure of this group account is incomplete or has an inactive account. Review the accounts in the chart of accounts.',
      TAX_RAIL_COA_VERSION_NOT_FOUND:
        'The chart of accounts was not found. Refresh the page and try again.',
      TAX_RAIL_COA_VERSION_NOT_ENSURABLE:
        'This chart of accounts was replaced. Set up the tax structure on the active chart.',
      TAX_RAIL_SLOT_NOT_ELIGIBLE:
        'This tax is not paid by guide, so it does not use staged managed accounts.',
      STAGED_TAX_RAIL_FRAMEWORK_MISMATCH:
        'Fiscal rails are available only for BR CPC accounting books.',
      fallback: 'This tax mapping could not be saved.',
    },
    railMigration: {
      title: 'Confirm tax-balance migration',
      description:
        'The mapped account will be retained as Legado (same UUID). The system will debit Legado and credit Apurado for each tax below. Enter the statutory assessment period for each balance — the journal effective date does not replace it.',
      tax: 'Tax',
      account: 'Legacy account',
      entity: 'Entity',
      book: 'Book',
      balance: 'Balance to migrate',
      scope: 'Journal details',
      scopeDescription: 'Entity {{entity}} · Book {{book}}',
      entityBook: 'Entity {{entityId}} · Book {{bookId}}',
      effectiveDate: 'Effective date',
      assessmentPeriod: 'Assessment period',
      effectiveDateRequired: 'Enter an effective date for each migrated balance.',
      assessmentPeriodRequired:
        'Enter the assessment period (month/year) for each migrated balance.',
      confirmation:
        'I confirm the reclassification of Legado balances to Apurado using the supplied assessment periods.',
      confirm: 'Confirm and record journal',
      confirming: 'Recording journal...',
      processingTitle: 'Recording migration',
      processingDescription: 'The fiscal rails and journals are being created.',
      processingBody: 'Please wait while we complete the migration. Do not close this window.',
      cancel: 'Cancel',
      close: 'Close',
      retry: 'Try again',
      successTitle: 'Migration recorded',
      successDescription: 'The fiscal rails and reclassification journals were created.',
      successBody: 'You can now return to fiscal configuration or approve the payroll RPA.',
      errorTitle: 'The migration could not be recorded',
      errorDescription: 'No rail or journal was created. Fix the indicated issue and try again.',
    },
    footer: {
      noChanges: 'No changes recorded',
      lastUpdated: 'Updated on {{date}}',
      unsavedChanges: 'Unsaved changes',
    },
    buttons: {
      discard: 'Discard changes',
      // This is the PLAIN save button (calls `handleSave`) — it commits whatever is already
      // filled in, AI-suggested or not. "Save settings" read as a generic settings save and,
      // worse, was easy to swap in a reviewer's head with `acceptSuggestions` below, which is the
      // AI-suggestions button — that mix-up misled two reviewers in a row (Bug 031-b).
      save: 'Save mappings',
      saving: 'Saving...',
      configureMappedRails_one: 'Configure 1 fiscal rail',
      configureMappedRails_other: 'Configure {{count}} fiscal rails',
      configuringRails: 'Configuring rails...',
      configureMappedRailsHelp:
        'Automatically creates the missing fiscal rails for accounts that are already mapped.',
      configureMappedRailsSaveFirst: 'Save mapping changes before configuring fiscal rails.',
      aiSuggest: 'Analyze and suggest accounts',
      aiSuggestAgain: 'Request new suggestions',
      aiSuggesting: 'Analyzing...',
      aiSuggestingWarning: 'Analyzing accounts, please stay on this page...',
      // This is the ACCEPT-AI-SUGGESTIONS button (calls `saveAllDrafts`) — it only shows up when
      // there are pending AI suggestions to confirm. Naming it "Save mappings" on a screen whose
      // whole job is mappings made it indistinguishable from the plain save button above.
      acceptSuggestions: 'Accept suggestions',
      acceptAndCreate: 'Save mappings and create accounts',
      acceptingAndCreating: 'Creating accounts...',
      discardHelp: 'Discards changes in this tab without saving.',
      saveMappingsHelp: 'Saves only the mappings already filled in the "GL account" column.',
      saveAndCreateHelp: 'Saves mappings and creates the new GL accounts suggested by Alchemy.',
    },
    bulkCreateConfirm: {
      title: 'Confirm account creation',
      description: 'Review and edit the accounts that will be created based on AI suggestions.',
      table: {
        slotName: 'Slot',
        accountName: 'Account name',
        accountCode: 'Account code',
        parentCode: 'Parent account',
        parentPlaceholder: 'Select parent account...',
        accountType: 'Type',
        naturalBalance: 'Natural balance',
        actions: 'Actions',
      },
      buttons: {
        confirm: 'Confirm and create accounts',
        cancel: 'Cancel',
        confirming: 'Creating accounts...',
        remove: 'Remove',
      },
      empty: 'No accounts to create.',
      validation: {
        nameRequired: 'Account name is required',
        codeRequired: 'Account code is required',
        parentRequired: 'Select a parent account.',
        duplicateCode: 'Duplicate account code',
        fixErrors: 'Review the required fields before continuing.',
        fixErrorsHint:
          'Fill in account name, code, and parent account on every highlighted row before confirming.',
        postableParentCode:
          'The following parent accounts are postable and cannot be used as parents: {{codes}}. Select non-postable (synthetic) accounts instead.',
        codesAlreadyExist:
          'The following codes already exist in the chart of accounts: {{codes}}. Please change the codes before continuing.',
        duplicateCodes:
          'The following codes are duplicated in the list: {{codes}}. Each account must have a unique code.',
      },
    },
    createAccountConfirm: {
      title: 'Confirm account creation',
      description: 'The GL account will be created and added to the chart of accounts. Confirm?',
      confirm: 'Confirm',
      cancel: 'Cancel',
    },
    loader: {
      title: 'Analyzing mappings...',
      subtitle: 'This may take up to 1 minute. Do not close or refresh the page.',
      processing: 'Processing',
      completed: 'Completed',
      dismiss: 'Dismiss',
      labels: {
        stage1: 'Extracting ore…',
        stage2: 'Smelting matter…',
        stage3: 'Purifying form…',
        stage4: 'Refining edges…',
        stage5: 'Transmuting to gold…',
      },
    },
    noActiveVersion: 'No active chart of accounts version (APPLIED) found.',
  },
  systemAccountMapping: {
    title: 'System accounts',
    subtitle: 'Map system slots to accounts in the active chart',
    loading: 'Loading system accounts...',
    error: 'Unable to load system accounts.',
    toasts: {
      saved: 'Settings saved.',
      saveError: 'Unable to save settings.',
      createAccountError: 'Unable to create the GL account.',
      aiSuggestSuccess_one: '1 suggestion applied',
      aiSuggestSuccess_other: '{{count}} suggestions applied',
      aiSuggestEmpty: 'All slots are already mapped or no suggestions found',
      aiSuggestError: 'Unable to suggest accounts. Please try again.',
    },
    footer: {
      noChanges: 'No changes recorded',
      lastUpdated: 'Updated on {{date}}',
    },
    buttons: {
      discard: 'Discard changes',
      save: 'Save settings',
      saving: 'Saving...',
      aiSuggest: 'Transmute accounts',
      aiSuggesting: 'Transmuting...',
    },
    module: {
      label: 'Module',
      description: 'Filter system slots by module',
      placeholder: 'Select a module',
    },
    modules: {
      ALL: 'All modules',
      AP: 'Accounts payable',
      AR: 'Accounts receivable',
      GL: 'General ledger',
      HCM: 'People',
      OP: 'Treasury',
      FA: 'Fixed assets',
    },
    mappings: {
      card: {
        title: 'System → GL account mappings',
        description:
          'Link each system slot to a postable account in the active chart of accounts. You can create accounts directly here.',
      },
      missingRequired: '{{count}} required missing',
      allRequiredMapped: 'Required ok',
      noActiveVersion: 'No active chart of accounts version (APPLIED) found.',
      createAccount: 'Create account',
      accountPlaceholder: 'Search account...',
      clear: 'Clear',
      slotsCount: '{{count}} slots',
      categoryRequiredMissing: '{{missing}}/{{total}} pending',
      categoryRequiredComplete: '{{total}} required ok',
      categories: {
        FINANCIAL_REVENUE: {
          name: 'Financial revenue',
          description: 'Financial discounts and positive variations',
        },
        FINANCIAL_EXPENSE: {
          name: 'Financial expense',
          description: 'Interest, penalties, and charges',
        },
        BANK_FEES: {
          name: 'Bank fees',
          description: 'Operational fees charged by the bank',
        },
        TAX_EXPENSE_PAYMENT: {
          name: 'Payment taxes',
          description: 'Taxes recognized at payment time (e.g., IOF)',
        },
        SUPPLIER_ADVANCE: {
          name: 'Supplier advances',
          description: 'Prepayments before receiving invoices',
        },
        CREDIT_CARD_LIABILITY: {
          name: 'Credit cards',
          description: 'Corporate card liabilities',
        },
        FX_VARIATION: {
          name: 'FX variation',
          description: 'Foreign exchange gains and losses',
        },
        PAYROLL_LIABILITY: {
          name: 'Payroll liabilities',
          description: 'Salary and payroll-related liabilities',
        },
        PAYROLL_ASSET: {
          name: 'Payroll assets',
          description: 'Employee advances and other payroll assets',
        },
        RECOVERY_REVENUE: {
          name: 'Recovery revenue',
          description: 'Reimbursements and expense recoveries',
        },
        CLIENT_RECOVERABLE_ADVANCE: {
          name: 'Client recoverable assets',
          description: 'Assets for expenses recoverable from clients',
        },
        VENDOR_LIABILITY: {
          name: 'Vendors',
          description: 'Vendor payables root — one child account per vendor',
        },
        CUSTOMER_RECEIVABLE: {
          name: 'Customers',
          description: 'Receivables root — one child account per customer',
        },
        BANK_ACCOUNT: {
          name: 'Bank accounts',
          description: 'Bank root — one child account per bank account',
        },
        INVESTMENT_SHORT_TERM: {
          name: 'Short-term investments',
          description: 'Current investments root — one child account per position',
        },
        INVESTMENT_LONG_TERM: {
          name: 'Long-term investments',
          description: 'Non-current investments root — one child account per position',
        },
        IN_TRANSIT: {
          name: 'Cash in transit',
          description: 'Transit account for internal transfers spanning dates',
        },
        CUSTODIAL_PAYABLE: {
          name: 'Custodial partner payable',
          description: 'Custodial liability root — one child account per partner (hotel)',
        },
        UNBILLED_RECEIVABLE: {
          name: 'Unbilled receivable',
          description:
            'Root for recognised transactions not yet billed — one child per partner; reclassified to customers receivable by the aggregate',
        },
        SERVICE_TAX_PAYABLE: {
          name: 'Service tax',
          description: 'Tax on our own service revenue (ISS, IVA), by stage: uncollected and due',
        },
        SERVICE_REVENUE: {
          name: 'Service revenue',
          description: 'Commission and fee revenue when the service declares no account of its own',
        },
        ACQUIRER_FEE_EXPENSE: {
          name: 'Acquirer fees',
          description: 'Discount rate the acquirer charges on each settled batch',
        },
        RECOVERABLE_TAX: {
          name: 'Recoverable tax',
          description: 'Creditable tax on fees and commissions (IVA acreditable)',
        },
        CARD_FINANCING_CLEARING: {
          name: 'Card-financed payments',
          description: 'Supplier payments the card financed that are not yet applied to a bill',
        },
        CONTRACT_ASSET: {
          name: 'Contract asset',
          description: 'Root for revenue recognized but not yet invoiced (IFRS 15)',
        },
        CONTRACT_LIABILITY: {
          name: 'Contract liability',
          description: 'Root for amounts invoiced but not yet recognized (IFRS 15)',
        },
        EXPENSE_ACCRUAL: {
          name: 'Expense accruals',
          description: 'Offset account for expenses accrued during month-end close',
        },
        RETAINED_EARNINGS: {
          name: 'Retained earnings',
          description: 'Receives the net result when the fiscal year is closed',
        },
        INTANGIBLE_IN_PROGRESS: {
          name: 'Intangible in progress',
          description:
            'Capitalised cost of development projects not yet placed in service (CPC 04 / IAS 38)',
        },
        PREPAID_EXPENSE: {
          name: 'Prepaid expenses',
          description:
            "Part of a bill that pays a later month's cost-service provision, held until that provision posts",
        },
      },
    },
  },
  approvalDefaults: {
    card: {
      title: 'Default behavior',
      description: 'How bills should be handled by default',
    },
    requireApproval: {
      title: 'Require approval by default',
      recommended: 'Recommended',
      description:
        'All bills require approval unless an auto-approval flow applies. Disable to allow bills to be processed without approval.',
    },
    autoSubmit: {
      title: 'Send automatically created bills to the approval workflow',
      recommended: 'Recommended',
      description:
        'Bills with a deterministic classification (rule, reuse, approved history, or AI matching an approved precedent) go straight to the approval workflow, with no manual submission. With no applicable chain they are approved; otherwise they await approvers. AI-only classifications with no precedent stay in Submitted.',
    },
    creditCard: {
      card: {
        title: 'Credit cards',
        description: 'Rules applied to credit card transactions.',
      },
      requireAttachment: {
        title: 'For credit card transactions, require attachment above:',
        description:
          'Transactions without an attachment above this amount are flagged in fast-track reconciliation and cannot be posted to the ledger.',
        ariaLabel: 'For credit card transactions, require attachment above amount',
        placeholder: '500',
      },
    },
    clientReimbursable: {
      card: {
        title: 'Client-reimbursable expenses',
        description:
          'Use WorkOS to control which tenants can mark AP bills as recoverable from clients.',
      },
      toggle: {
        title: 'Enable client-reimbursable expenses',
        description:
          'When enabled, AP bills can be marked as reimbursable by a client and treated as a recoverable asset instead of a final expense.',
        notEditableFallback: 'This flag is controlled by WorkOS and is not editable.',
      },
    },
    defaultBillEntity: {
      card: {
        title: 'Default entity for bills',
        description:
          'Applied at the start of bill processing when no tenant entity is identified in the documents, e-mail, or instructions. Accepted identifiers: CNPJ, Mexican RFC, and US EIN.',
      },
      selector: {
        label: 'Default entity',
        placeholder: 'None (use channel entity)',
        clearLabel: 'None',
      },
      loading: 'Loading default entity...',
      loadError: 'Could not load the default bill entity.',
      saveError: 'Could not save the default bill entity.',
    },
  },
  cardFastTrack: {
    page: {
      title: 'Card fast-track',
      subtitle: 'Classify and post card transactions quickly',
    },
    filters: {
      entityPlaceholder: 'Select an entity',
      allPeriods: 'All periods',
      attachmentThreshold: 'Attachment required above {{amount}}',
      searchPlaceholder: 'Search by transaction',
      amountMinPlaceholder: 'Min amount',
      amountMaxPlaceholder: 'Max amount',
      amountInputPlaceholder: '$0.00',
      amountFilterAria: 'Filter by amount',
      datePlaceholder: 'Filter by date',
      transactionPlaceholder: 'Filter transaction',
      vendorPlaceholder: 'Filter vendor',
      glAccountPlaceholder: 'Filter GL account',
      managerialAccountPlaceholder: 'Filter managerial account',
      costCenterPlaceholder: 'Filter cost center',
      departmentPlaceholder: 'Filter department',
      apply: 'Apply',
      clear: 'Clear',
      active: {
        title: 'Active filters',
        transaction: 'Transaction: {{value}}',
        date: 'Date: {{from}} – {{to}}',
        cards: '{{count}} card(s)',
        amount: 'Amount: {{min}} – {{max}}',
        vendors: '{{count}} vendor(s)',
        glAccounts: '{{count}} GL account(s)',
        managerialAccounts: '{{count}} managerial account(s)',
        costCenters: '{{count}} cost center(s)',
        departments: '{{count}} department(s)',
        clearAll: 'Clear all',
      },
      cards: {
        allCards: 'All cards',
        oneCard: '1 card',
        manyCards: '{{count}} cards',
      },
    },
    tabs: {
      ready: 'Ready',
      incomplete: 'Incomplete',
      refunds: 'Refunds',
      pendingApproval: 'Pending approval',
      ignored: 'Ignored',
      all: 'All',
    },
    empty: {
      selectEntity: 'Select an entity to view transactions',
      noEntitiesTitle: 'No entities available',
      noEntitiesDescription:
        'Register an entity or resolve the entity loading issue to access transactions.',
      noTransactions: 'No transactions found',
      adjustFilters: 'Adjust the filters to broaden the results',
    },
    table: {
      attachmentAdded: 'Attachment added',
      attachmentRequired: 'Attachment required above {{amount}}',
      attachmentRequiredHelp: 'Attach a receipt to allow posting to the ledger.',
      setVendor: 'Set vendor',
      automaticClaraVendor: 'Clara',
      automaticContaSimplesVendor: 'Conta Simples',
      automatic: 'Automatic',
      automaticClaraVendorHelp:
        'Clara IOF fee. The vendor and entry are set automatically when posted.',
      automaticContaSimplesVendorHelp:
        'Conta Simples IOF fee. The vendor and entry are set automatically when posted.',
      automaticClaraMxVendorHelp:
        'Clara Mexico card charge (commission, interest, late charge or IVA). The vendor and entry are set automatically when posted.',
      automaticMappedAccountHelp: 'Account mapped in Accounting Mappings',
      acceptSuggestion: 'Accept suggestion',
      setGlAccount: 'Set GL account',
      setManagerialAccount: 'Set managerial account',
      setCostCenter: 'Set cost center',
      setDepartment: 'Set department',
      approve: 'Approve',
      reject: 'Reject',
      selectAll: 'Select all transactions',
      selectTransaction: 'Select transaction',
      refundBadge: 'Refund',
      refundHelp: 'Card refund. It is not booked as an expense; handle it in the Refunds tab.',
      date: 'Date',
      transaction: 'Transaction',
      amount: 'Amount',
      vendor: 'Vendor',
      glAccount: 'GL account',
      managerialAccount: 'Managerial account',
      costCenter: 'Cost center',
      department: 'Department',
      attachment: 'Attachment',
      filterColumn: 'Filter column',
      resizeColumn: 'Resize column',
    },
    toast: {
      billApproved: 'Bill approved successfully',
      billApproveError: 'Could not approve the bill',
      billRejected: 'Bill rejected successfully',
      billRejectError: 'Could not reject the bill',
      classificationSaved: 'Classification saved successfully',
      classificationSaveError: 'Failed to save classification',
      vendorSetError: 'Failed to assign vendor',
      vendorClearError: 'Failed to clear vendor',
    },
    footer: {
      clear: 'Clear selection',
      selectedCount_one: '{{count}} selected',
      selectedCount_other: '{{count}} selected',
    },
    pagination: {
      range: '{{start}}-{{end}} of {{total}}',
      perPage: 'per page:',
      pageOf: 'Page {{page}} of {{totalPages}}',
    },
    common: {
      cancel: 'Cancel',
      back: 'Back',
    },
    bulk: {
      button: 'Bulk actions',
      selectedBadge_one: '{{count}} selected',
      selectedBadge_other: '{{count}} selected',
      menuTitle: 'Bulk actions',
      failureReasons: {
        cancelled: 'Cancelled transactions cannot be reconciled',
        refundNotSupported:
          'Card refunds are not booked as expenses; handle them in the Refunds tab',
      },
      menu: {
        classifyTitle: 'Classify',
        classifyDescription: 'Set GL account, cost center, and department',
        vendorTitle: 'Assign vendor',
        vendorDescription: 'Set the same vendor for all selected items',
        vendorAdvanceTitle: 'Vendor advance',
        vendorAdvanceDescription:
          'Create vendor advance bills linked to the selected card transactions',
        postTitle: 'Post to ledger',
        postDescription: 'Create bills and post to the ledger',
        postBlockedMissingVendor_one: '{{count}} missing vendor',
        postBlockedMissingVendor_other: '{{count}} missing vendor',
        postBlockedMissingAttachment_one: '{{count}} missing attachment',
        postBlockedMissingAttachment_other: '{{count}} missing attachments',
      },
      warnings: {
        missingVendor_one: '{{count}} transaction has no vendor - set a vendor before posting',
        missingVendor_other: '{{count}} transactions have no vendor - set a vendor before posting',
        missingAttachment_one:
          '{{count}} transaction requires an attachment before posting to the ledger',
        missingAttachment_other:
          '{{count}} transactions require an attachment before posting to the ledger',
      },
      toasts: {
        posted_one: '{{count}} transaction posted to the ledger',
        posted_other: '{{count}} transactions posted to the ledger',
        pendingApproval_one: '{{count}} pending approval',
        pendingApproval_other: '{{count}} pending approval',
        failed_one: '{{count}} transaction failed',
        failed_other: '{{count}} transactions failed',
        postError: 'Failed to post transactions',
        vendorAssigned_one: 'Vendor assigned to {{count}} transaction',
        vendorAssigned_other: 'Vendor assigned to {{count}} transactions',
        vendorAssignError: 'Failed to assign vendor',
        classified_one: '{{count}} transaction classified',
        classified_other: '{{count}} transactions classified',
        classifyError: 'Failed to classify transactions',
      },
      postConfirm: {
        title: 'Post to ledger',
        description_one:
          'Post {{count}} transaction to the ledger? Bills will be created automatically.',
        description_other:
          'Post {{count}} transactions to the ledger? Bills will be created automatically.',
        attachmentHint: 'Attachment required above {{amount}}.',
        confirmLoading: 'Posting...',
        confirm: 'Confirm {{count}}',
      },
      vendor: {
        title: 'Assign vendor',
        fieldLabel: 'Vendor',
        placeholder: 'Select a vendor',
        confirmLoading: 'Assigning...',
        confirm: 'Assign {{count}}',
      },
      classify: {
        title: 'Classify transactions',
        vendorLabel: 'Vendor',
        vendorPlaceholder: 'Select a vendor',
        glLabel: 'GL account',
        glPlaceholder: 'Select an account',
        managerialLabel: 'Managerial account',
        managerialPlaceholder: 'Select a managerial account',
        costCenterLabel: 'Cost center',
        costCenterPlaceholder: 'Select a cost center',
        departmentLabel: 'Department',
        departmentPlaceholder: 'Select a department',
        notesLabel: 'Notes',
        notesPlaceholder: 'Optional notes...',
        confirmLoading: 'Classifying...',
        confirm: 'Classify {{count}}',
      },
    },
    ...cardRefundsEn,
    readyToPost: {
      title: 'Bills ready to post',
      description_one: '{{count}} bill is ready. Post it to the ledger now?',
      description_other: '{{count}} bills are ready. Post them to the ledger now?',
      later: 'Not now',
      confirm: 'Post to ledger',
      posting: 'Posting...',
    },
  },
};
